(function() {
    'use strict';

    angular
        .module('getwellApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('getwellApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('getwellApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'JhiTrackerService'];

    function Principal ($q, Account, JhiTrackerService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                JhiTrackerService.connect();
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' , 'JhiTrackerService'];

    function AuthServerProvider ($http, $localStorage , JhiTrackerService) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {
            JhiTrackerService.disconnect();

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    JhiTrackerService.sendActivity();
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('scheduler', {
            parent: 'app',
            url: '/calendar',
            data: {
                authorities: ['ROLE_PRACTICE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/scheduler/scheduler.html',
                    controller: 'SchedulerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('scheduler');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('SchedulerController', SchedulerController);

    SchedulerController.$inject = ['$scope', 'Principal', 'Practice', 'Appointment', '$stateParams', '$window'];

    function SchedulerController ($scope, Principal, Practice, Appointment, $stateParams, $window) {
        var vm = this;
        
//        vm.practiceId = $stateParams.practiceId;
        vm.updateCalendar = updateCalendar;
        vm.initPracticeAndCalendars = initPracticeAndCalendars;
        vm.initLightboxSections = initLightboxSections;
        
        Principal.identity().then(function(account) {
        	var practiceId = account.practice;
        	initPracticeAndCalendars(practiceId);
        });
        
//        var scheduler2 = Scheduler.getSchedulerInstance();
//        initScheduler(scheduler2, 'calendar-2');
        
        function initPracticeAndCalendars(practiceId) {
            vm.practice = Practice.getWithCalendars({id: practiceId},
                    function (result) {
        	        	// TODO [dom] really necessary?
        	            vm.practice = result;
        	            
        	            // unfortunately, scheduler state is outside of angularjs view or session lifecycle
        	            if (scheduler.isInitialized !== true) {
        	            	initScheduler(scheduler);
        	            	vm.initLightboxSections();
        	            	scheduler.isInitialized = true;
        	            }
        	            scheduler.init('scheduler-1', new Date(), "week");

        	            reloadSchedulerIfCalendarsChanged();

        	            // TODO [dom] what should happen when there is no calendar in this practice?
        	            vm.selectedCalendar = vm.practice.resourceCalendars[0].id;
        	            vm.updateCalendar();
                });
        }

        function reloadSchedulerIfCalendarsChanged() {
            // TODO [dom] do this also for resource calendars
            var personCalendarIds = vm.practice.personCalendars.map(function(calendar) { return calendar.id; });
            var schedulerCalendarOptions = scheduler.config.lightbox.sections.find(function(section) { return section.name === 'persons'; } ).options;

            if (personCalendarIds.length != schedulerCalendarOptions.length) {
                $window.location.reload();
            } else {
                if (schedulerCalendarOptions.find(function(option) { return !personCalendarIds.includes(option.key); })) {
                    $window.location.reload();
                }
            }
        }

        function getPersonCalendar(id) {
        	return vm.practice.personCalendars.find(function(cal) { return cal.id == id });
        }

        function getResourceCalendar(id) {
        	return vm.practice.resourceCalendars.find(function(cal) { return cal.id == id });
        }
        
        function updateCalendarOptionDefaults() {
        	// TODO [dom] add some more logic, e.g. if only one calendar present, select that automatically, when more are present, select first etc.
        	var personCalendar = getPersonCalendar(vm.selectedCalendar);
        	if (personCalendar !== undefined) {
        		scheduler.defaultPersonCalendar = {id: vm.selectedCalendar};
        		scheduler.defaultResourceCalendar = {id: personCalendar.defaultRelatedCalendarId};
        	} else {
        		var resourceCalendar = getResourceCalendar(vm.selectedCalendar);
        		scheduler.defaultPersonCalendar = {id: resourceCalendar.defaultRelatedCalendarId};
        		scheduler.defaultResourceCalendar = {id: vm.selectedCalendar};
        	}
        }
        
        function updateCalendar() {
        	updateCalendarOptionDefaults();
        	
        	vm.events = Appointment.query({calendarId: vm.selectedCalendar},
            	function(result) {
    	        	// TODO [dom] really necessary?
    	            vm.events = result;

    	            scheduler.clearAll();
    	            scheduler.parse(vm.events, "json");
            });
        }
        
        function initLightboxSections() {
            var personCalendarOptions = vm.practice.personCalendars.map(function(calendar) {
            	return {key: calendar.id, label: calendar.name};
            });
            var resourceCalendarOptions = vm.practice.resourceCalendars.map(function(calendar) {
            	return {key: calendar.id, label: calendar.name};
            });
        	
        	// TODO [dom] insert type in label files instead, and insert labels for options in label files
            scheduler.locale.labels.drag_to_create = "Ziehen zum Erstellen";
            scheduler.locale.labels.drag_to_move = "Bewegen zum Verschieben";
            scheduler.locale.labels.message_cancel = "Abbrechen";
        	scheduler.locale.labels.section_type = "Typ";
        	scheduler.locale.labels.section_persons = "Personen";
        	scheduler.locale.labels.section_resources = "Ressourcen";
        	scheduler.locale.labels.section_repeat = "Wiederholung";
        	scheduler.locale.labels.section_repetition = "Anzahl Wieder.";
       		scheduler.config.lightbox.sections=[
    		    {name:"description", height:200, map_to:"text", type:"textarea" , focus:true},
    		    {name:"type", height:46, map_to:"type", type:"radio", options: [{key:"BOOKABLE", label:"buchbar"}, {key:"OCCUPIED", label:"belegt"}], vertical: true, default_value: "OCCUPIED"},
    		    {name:"persons", height:26*personCalendarOptions.length, map_to:"personCalendarIds", type:"multiselect", options: personCalendarOptions, vertical: true},
    		    {name:"resources", height:26*resourceCalendarOptions.length, map_to:"resourceCalendarIds", type:"multiselect", options: resourceCalendarOptions, vertical: true},
    		    {name:"time", height:72, type:"time", map_to:"auto"},
    		    {name:"repeat", height:26, map_to:"repeat", type:"select", onchange: updateRepetitionState, options: [{key:"ONCE", label:"Einmalig"}, {key:"WORKDAYS", label:"Arbeitstäglich"}, {key:"WEEKS", label:"Wöchentlich"}] },
    		    {name:"repetition", height:10, map_to:"repetition", type:"textarea"}
    		]
        }

        function updateRepetitionState() {
            var repetitionElement = $(".dhx_cal_ltext").eq(3); // the repetition element currently is the fourth element with the class 'dhx_cal_ltext'
            var disabled = $("option[value=ONCE]").parent().val() == 'ONCE'; // if the value 'ONCE' is selected, we want to disable the repetition field
            var targetHeight = disabled ? "10px" : "28px";

            repetitionElement.css('height', targetHeight);
            if (disabled) {
                repetitionElement.children('textarea').val('');
            }
        }
        
        function configureSchedulerFullweekTab(schedulerInstance) {
            schedulerInstance.date.fullweek_start = function(date) {
                return schedulerInstance.date.week_start(date);
            };
            schedulerInstance.date.get_fullweek_end = function(start_date) {
                return schedulerInstance.date.add(start_date,7,"day"); 
            };
            schedulerInstance.date.add_fullweek = function(date,inc) { 
                return schedulerInstance.date.add(date,inc*7,"day");
            };
            schedulerInstance.templates.fullweek_date = schedulerInstance.templates.week_date;
            schedulerInstance.templates.fullweek_scale_date = schedulerInstance.templates.week_scale_date;
        }
        
        function initScheduler(schedulerInstance) {
        	schedulerInstance.skin = 'flat'
//        	schedulerInstance.config.xml_date="%Y-%m-%dT%H:%i:%sZ";
        	schedulerInstance.config.server_utc = true;
        	schedulerInstance.config.day_date = "%D, %j.%n.";
        	schedulerInstance.config.scroll_hour = 7;
        	schedulerInstance.config.details_on_dblclick = true;
        	schedulerInstance.config.details_on_create = true;
        	schedulerInstance.config.separate_short_events = true;
        	schedulerInstance.config.time_step = 15;
        	schedulerInstance.config.hour_size_px = 64;
        	schedulerInstance.xy.min_event_height = 16;


        	schedulerInstance.templates.event_class = function(start, end, event) {
				var css = "event_" + event.type;

				if (event.id == scheduler.getState().select_id) {
					css += " selected";
				}
				return css;
			};

			schedulerInstance.renderEvent = function(container, ev, w, h, contentA, contentB) {
				// the following code is heavily based on the function scheduler._render_v_bar from the source of dhtmlxscheduler.js version v.4.4.0. Beware, that on new versions, the code might have to be updated!
				var bg_color = (ev.color ? ("background:" + ev.color + ";") : "");
				var color = (ev.textColor ? ("color:" + ev.textColor + ";") : "");
				
				var inner_html = '<div class="dhx_event_move dhx_header" style=" width:' + (w - 6) + 'px;' + bg_color + '" >&nbsp;</div>';

				var body_classes_small = 'dhx_event_move dhx_body_small ';
				var body_height = 14;
				var event_duration_in_min = (ev.end_date - ev.start_date) / 60000;
				if ( event_duration_in_min > 30) {
					inner_html += '<div class="dhx_event_move dhx_title" style="' + bg_color + '' + color + '">' + contentA + '</div>';
					body_classes_small = '';
					body_height = (h - (this._quirks ? 20 : 30) + 1);
				} else {
					if ( event_duration_in_min > 15) {
						body_height = 30;
					}
				}
				inner_html += '<div class="' + body_classes_small + 'dhx_body" style=" width:' + (w - (this._quirks ? 4 : 14)) + 'px; height:' + body_height + 'px;' + bg_color + '' + color + '">' + contentB + '</div>';

				var footer_class = "dhx_event_resize dhx_footer";
				inner_html += '<div class="' + footer_class + '" style=" width:' + (w - 8) + 'px;' + bg_color + '' + color + '" ></div>';
	
				container.innerHTML = inner_html;
				
				return true;
			};
			
			// 0 refers to Sunday, 6 to Saturday
			schedulerInstance.ignore_week = function(date) {
			    if (date.getDay() == 6 || date.getDay() == 0) { // hides Saturdays and Sundays
			        return true;
			    }
			};
			
        	initResponsive(schedulerInstance);
        	
        	schedulerInstance.locale.labels.week_tab = "5 Tage";
        	schedulerInstance.locale.labels.fullweek_tab = "Woche";
        	schedulerInstance.attachEvent("onTemplatesReady", function() {
        	    configureSchedulerFullweekTab(schedulerInstance);
        	});
        	
        	// set calendar option defaults
        	schedulerInstance.attachEvent("onEventCreated", function(id) {
    	         var event = schedulerInstance.getEvent(id);
    	         event.personCalendarIds = schedulerInstance.defaultPersonCalendar !== undefined ? schedulerInstance.defaultPersonCalendar['id'] : undefined;
    	         event.resourceCalendarIds = schedulerInstance.defaultResourceCalendar !== undefined ? schedulerInstance.defaultResourceCalendar['id'] : undefined;
        	});

        	schedulerInstance.attachEvent("onLightbox", function(id) {
        	    updateRepetitionState();
        	});

        	schedulerInstance.attachEvent("onEventChanged", function(id, event) {
        		console.log("Changing: id:" + id + " event:" + event);
        		handleRepetition(event);
                Appointment.update(event, function (result) {
                	// TODO [dom] event may not belong to current calendar anymore. refresh events?
                	console.log("Success!")
                	// TODO [dom] find way to set all fields back from persisted entity
                	event.lockingVersion = result.lockingVersion;
                	schedulerInstance.changeEventId(id, result.id);
                }, onSaveError);
        	});

        	schedulerInstance.attachEvent("onEventAdded", function(id, event) {
        		console.log("Adding: id:" + id + " event:" + event);
        		handleRepetition(event);
        		Appointment.save(event, function (result) {
        			// TODO [dom] event may not belong to current calendar. refresh events?
                	console.log("Success!")
                	console.log("Event id before:" + event.id);
                	// TODO [dom] find way to set all fields back from persisted entity
                	event.lockingVersion = result.lockingVersion;
                	schedulerInstance.changeEventId(id, result.id);
                	console.log("Event id after:" + event.id);
                }, onSaveError);
        	});
        	
        	schedulerInstance.attachEvent("onConfirmedBeforeEventDelete", function(id, event) {
        		if(event.lockingVersion != undefined) { // only try to delete if event already exists in DB
	        		console.log("Deleting: id:" + id + " event:" + event);
	        		
	                Appointment.delete({id: id}, onSaveSuccess, onSaveError);
	        	    // TODO [dom] check if there needs to be some additional error-handling done
        		}
        		return true;
        	});

        	function handleRepetition(event) {
        	    var resultingEventIds = [];
        	    var repetitionNumber = Number(event.repetition);
        	    repetitionNumber = Math.min(repetitionNumber, 5); // we only want to support a maximum repetition of 5

        	    if ((event.repeat == 'WORKDAYS' || event.repeat == 'WEEKS') && repetitionNumber > 0) {
        	        var isRepeatDays = event.repeat == 'WORKDAYS';
        	        var isDefaultText = event.text == 'neuer Eintrag';
        	        event.repeat = 'ONCE';
        	        event.repetition = '';
        	        var currentStartTime = moment(event.start_date);
        	        var currentEndTime = moment(event.end_date);

        	        for (var i=0;i<repetitionNumber;i++) {
        	            currentStartTime = isRepeatDays ? addWeekdays(currentStartTime, 1) : currentStartTime.clone().add(1, 'w');
        	            currentEndTime = isRepeatDays ? addWeekdays(currentEndTime, 1) : currentEndTime.clone().add(1, 'w');

        	            var newEventId = schedulerInstance.addEvent({
        	                    text: isDefaultText ? event.text : event.text + ' ' + (i+2),
        	                    type: event.type,
        	                    personCalendarIds: event.personCalendarIds.slice(),
        	                    resourceCalendarIds: event.resourceCalendarIds.slice(),
        	                    start_date: currentStartTime.toDate(),
        	                    end_date: currentEndTime.toDate(),
        	                    repeat: 'ONCE',
        	                    repetition: ''
        	                });

        	            resultingEventIds.push(newEventId);
        	        }
        	    }
        	    return resultingEventIds;
        	}

        	function addWeekdays(date, days) {
        	    date = date.clone();
        	    while (days > 0) {
        	        date = date.add(1, 'days');
        	        if ((date.isoWeekday() !== 6) && (date.isoWeekday() !== 7)) {
        	            days -= 1;
        	        }
        	    }
        	    return date;
        	}
        	
            function onSaveSuccess (result) {
            	console.log("Success!");
            }

            function onSaveError (httpResponse) {
            	// TODO [dom] show error message to user incl. translations, e.g. for 'error.concurrencyFailure'
            	console.log("Error: " + JSON.stringify(httpResponse));
            }
        }
    }
})();


// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array/find
if (!Array.prototype.find) {
  Array.prototype.find = function(predicate) {
    'use strict';
    if (this == null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    var value;

    for (var i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function(valueToFind, fromIndex) {

      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      // 1. Let O be ? ToObject(this value).
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(valueToFind, elementK) is true, return true.
        if (sameValueZero(o[k], valueToFind)) {
          return true;
        }
        // c. Increase k by 1.
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        
        $scope.$on('authenticationSuccess', function() {
            getAccount();
            Principal.hasAuthority("ROLE_PRACTICE").then(function(value) {
            	if(value) {
                	$state.go('scheduler');
                }
          	});
        });
        
        getAccount();
        
        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentExperienceResponseDialogController', TreatmentExperienceResponseDialogController);

    TreatmentExperienceResponseDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TreatmentExperienceResponse'];

    function TreatmentExperienceResponseDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TreatmentExperienceResponse) {
        var vm = this;

        vm.treatmentExperienceResponse = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.treatmentExperienceResponse.id !== null) {
                TreatmentExperienceResponse.update(vm.treatmentExperienceResponse, onSaveSuccess, onSaveError);
            } else {
                TreatmentExperienceResponse.save(vm.treatmentExperienceResponse, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:treatmentExperienceResponseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentExperienceResponseDetailController', TreatmentExperienceResponseDetailController);

    TreatmentExperienceResponseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TreatmentExperienceResponse'];

    function TreatmentExperienceResponseDetailController($scope, $rootScope, $stateParams, previousState, entity, TreatmentExperienceResponse) {
        var vm = this;

        vm.treatmentExperienceResponse = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:treatmentExperienceResponseUpdate', function(event, result) {
            vm.treatmentExperienceResponse = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentExperienceResponseDeleteController',TreatmentExperienceResponseDeleteController);

    TreatmentExperienceResponseDeleteController.$inject = ['$uibModalInstance', 'entity', 'TreatmentExperienceResponse'];

    function TreatmentExperienceResponseDeleteController($uibModalInstance, entity, TreatmentExperienceResponse) {
        var vm = this;

        vm.treatmentExperienceResponse = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TreatmentExperienceResponse.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('treatment-experience-response', {
            parent: 'entity',
            url: '/treatment-experience-response?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.treatmentExperienceResponse.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/treatment-experience-response/treatment-experience-responses.html',
                    controller: 'TreatmentExperienceResponseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('treatmentExperienceResponse');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('treatment-experience-response-detail', {
            parent: 'treatment-experience-response',
            url: '/treatment-experience-response/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.treatmentExperienceResponse.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/treatment-experience-response/treatment-experience-response-detail.html',
                    controller: 'TreatmentExperienceResponseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('treatmentExperienceResponse');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TreatmentExperienceResponse', function($stateParams, TreatmentExperienceResponse) {
                    return TreatmentExperienceResponse.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'treatment-experience-response',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('treatment-experience-response-detail.edit', {
            parent: 'treatment-experience-response-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience-response/treatment-experience-response-dialog.html',
                    controller: 'TreatmentExperienceResponseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TreatmentExperienceResponse', function(TreatmentExperienceResponse) {
                            return TreatmentExperienceResponse.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('treatment-experience-response.new', {
            parent: 'treatment-experience-response',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience-response/treatment-experience-response-dialog.html',
                    controller: 'TreatmentExperienceResponseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                date: null,
                                message: null,
                                name: null,
                                pictureUrl: null,
                                published: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('treatment-experience-response', null, { reload: 'treatment-experience-response' });
                }, function() {
                    $state.go('treatment-experience-response');
                });
            }]
        })
        .state('treatment-experience-response.edit', {
            parent: 'treatment-experience-response',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience-response/treatment-experience-response-dialog.html',
                    controller: 'TreatmentExperienceResponseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TreatmentExperienceResponse', function(TreatmentExperienceResponse) {
                            return TreatmentExperienceResponse.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('treatment-experience-response', null, { reload: 'treatment-experience-response' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('treatment-experience-response.delete', {
            parent: 'treatment-experience-response',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience-response/treatment-experience-response-delete-dialog.html',
                    controller: 'TreatmentExperienceResponseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TreatmentExperienceResponse', function(TreatmentExperienceResponse) {
                            return TreatmentExperienceResponse.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('treatment-experience-response', null, { reload: 'treatment-experience-response' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('TreatmentExperienceResponse', TreatmentExperienceResponse);

    TreatmentExperienceResponse.$inject = ['$resource', 'DateUtils'];

    function TreatmentExperienceResponse ($resource, DateUtils) {
        var resourceUrl =  'api/treatment-experience-responses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentExperienceResponseController', TreatmentExperienceResponseController);

    TreatmentExperienceResponseController.$inject = ['$scope', '$state', 'TreatmentExperienceResponse', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TreatmentExperienceResponseController ($scope, $state, TreatmentExperienceResponse, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            TreatmentExperienceResponse.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.treatmentExperienceResponses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentExperienceDialogController', TreatmentExperienceDialogController);

    TreatmentExperienceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'TreatmentExperience', 'Booking', 'TreatmentExperienceResponse'];

    function TreatmentExperienceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, TreatmentExperience, Booking, TreatmentExperienceResponse) {
        var vm = this;

        vm.treatmentExperience = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            
            if(vm.treatmentExperience.booking != null && vm.treatmentExperience.booking.id == null) {
            	vm.treatmentExperience.booking = null;
            }
            
            if(vm.treatmentExperience.treatmentExperienceResponse != null && vm.treatmentExperience.treatmentExperienceResponse.id == null) {
            	vm.treatmentExperience.treatmentExperienceResponse = null;
            }
            
            if (vm.treatmentExperience.id !== null) {
                TreatmentExperience.update(vm.treatmentExperience, onSaveSuccess, onSaveError);
            } else {
                TreatmentExperience.save(vm.treatmentExperience, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:treatmentExperienceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentExperienceDetailController', TreatmentExperienceDetailController);

    TreatmentExperienceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TreatmentExperience', 'Booking', 'TreatmentExperienceResponse'];

    function TreatmentExperienceDetailController($scope, $rootScope, $stateParams, previousState, entity, TreatmentExperience, Booking, TreatmentExperienceResponse) {
        var vm = this;

        vm.treatmentExperience = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:treatmentExperienceUpdate', function(event, result) {
            vm.treatmentExperience = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentExperienceDeleteController',TreatmentExperienceDeleteController);

    TreatmentExperienceDeleteController.$inject = ['$uibModalInstance', 'entity', 'TreatmentExperience'];

    function TreatmentExperienceDeleteController($uibModalInstance, entity, TreatmentExperience) {
        var vm = this;

        vm.treatmentExperience = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TreatmentExperience.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('treatment-experience', {
            parent: 'entity',
            url: '/treatment-experience?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.treatmentExperience.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/treatment-experience/treatment-experiences.html',
                    controller: 'TreatmentExperienceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('treatmentExperience');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('treatment-experience-detail', {
            parent: 'treatment-experience',
            url: '/treatment-experience/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.treatmentExperience.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/treatment-experience/treatment-experience-detail.html',
                    controller: 'TreatmentExperienceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('treatmentExperience');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TreatmentExperience', function($stateParams, TreatmentExperience) {
                    return TreatmentExperience.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'treatment-experience',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('treatment-experience-detail.edit', {
            parent: 'treatment-experience-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience/treatment-experience-dialog.html',
                    controller: 'TreatmentExperienceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TreatmentExperience', function(TreatmentExperience) {
                            return TreatmentExperience.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('treatment-experience.new', {
            parent: 'treatment-experience',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience/treatment-experience-dialog.html',
                    controller: 'TreatmentExperienceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                date: null,
                                good: null,
                                improvementPotential: null,
                                summary: null,
                                published: null,
                                categoryGeneral: null,
                                categoryInformation: null,
                                categoryTimeTaken: null,
                                categoryFurnishing: null,
                                categoryCostBenefit: null,
                                categoryPainlessness: null,
                                overallRating: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('treatment-experience', null, { reload: 'treatment-experience' });
                }, function() {
                    $state.go('treatment-experience');
                });
            }]
        })
        .state('treatment-experience.edit', {
            parent: 'treatment-experience',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience/treatment-experience-dialog.html',
                    controller: 'TreatmentExperienceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TreatmentExperience', function(TreatmentExperience) {
                            return TreatmentExperience.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('treatment-experience', null, { reload: 'treatment-experience' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('treatment-experience.delete', {
            parent: 'treatment-experience',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience/treatment-experience-delete-dialog.html',
                    controller: 'TreatmentExperienceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TreatmentExperience', function(TreatmentExperience) {
                            return TreatmentExperience.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('treatment-experience', null, { reload: 'treatment-experience' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('TreatmentExperience', TreatmentExperience);

    TreatmentExperience.$inject = ['$resource', 'DateUtils'];

    function TreatmentExperience ($resource, DateUtils) {
        var resourceUrl =  'api/treatment-experiences/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentExperienceController', TreatmentExperienceController);

    TreatmentExperienceController.$inject = ['$scope', '$state', 'TreatmentExperience', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TreatmentExperienceController ($scope, $state, TreatmentExperience, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            TreatmentExperience.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.treatmentExperiences = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentDialogController', TreatmentDialogController);

    TreatmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Treatment', 'Practice', 'Coupon'];

    function TreatmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Treatment, Practice, Coupon) {
        var vm = this;

        vm.treatment = entity;
        vm.clear = clear;
        vm.save = save;
        // TODO [dom] change implementation here such that only the id (and not the whole practice object) is used
        //vm.practices = Practice.query();

        //vm.coupons = Coupon.query();
        vm.coupons = Coupon.query({size: 2000});
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            
            if(vm.treatment.displayOnPlatform == false && vm.treatment.displayOnStandalone == false) {
            	alert("AT LEAST one of the two display modes needs to be selected!");
            	onSaveError();
            } else if (vm.treatment.type == "CUSTOM" && (vm.treatment.customName == null || vm.treatment.customName == "")) {
            	alert("The custom name must be set when this treatment type is selected!");
            	onSaveError();
            } else if((vm.treatment.type == "CUSTOM" && vm.treatment.displayOnStandalone == false) || (vm.treatment.type == "CUSTOM" && vm.treatment.displayOnPlatform == true)) {
            	alert("The custom type can only be selected on a STANDALONE only displayed treatment!");
            	onSaveError();
            } else {
                if (vm.treatment.id !== null) {
                    Treatment.update(vm.treatment, onSaveSuccess, onSaveError);
                } else {
                    Treatment.save(vm.treatment, onSaveSuccess, onSaveError);
                }             
            	onSaveError();
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:treatmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentDetailController', TreatmentDetailController);

    TreatmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Treatment', 'Practice', 'Coupon'];

    function TreatmentDetailController($scope, $rootScope, $stateParams, previousState, entity, Treatment, Practice, Coupon) {
        var vm = this;

        vm.treatment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:treatmentUpdate', function(event, result) {
            vm.treatment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentDeleteController',TreatmentDeleteController);

    TreatmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Treatment'];

    function TreatmentDeleteController($uibModalInstance, entity, Treatment) {
        var vm = this;

        vm.treatment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Treatment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('treatment', {
            parent: 'entity',
            url: '/treatment?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.treatment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/treatment/treatments.html',
                    controller: 'TreatmentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('treatment');
                    $translatePartialLoader.addPart('treatmentType');
                    $translatePartialLoader.addPart('currency');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('treatment-detail', {
            parent: 'treatment',
            url: '/treatment/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.treatment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/treatment/treatment-detail.html',
                    controller: 'TreatmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('treatment');
                    $translatePartialLoader.addPart('treatmentType');
                    $translatePartialLoader.addPart('currency');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Treatment', function($stateParams, Treatment) {
                    return Treatment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'treatment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('treatment.add-default-treatments', {
        	parent: 'treatment',
        	url: '/add-default-treatments',
        	data: {
        		authorities: ['ROLE_USER']
        	},
        	onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        		$uibModal.open({
        			templateUrl: 'app/entities/treatment/add-default-treatments-dialog.html',
        			controller: 'AddDefaultTreatmentsDialogController',
        			controllerAs: 'vm',
        			backdrop: 'static',
        			size: 'lg',
        			resolve: {
        				entity: function () {
        					return {
        						fixedPrice: null,
        						minPrice: null,
        						maxPrice: null,
        						type: null,
        						duration: 30,
        						currency: 'CHF',
        						showPrice: false,
        						showDuration: false,
        						displayOnStandalone: true,
        						displayOnPlatform: true,
        						customName: null,
                                sortingOrder: null,
                                id: null
        					};
        				}
        			}
        		}).result.then(function() {
        			$state.go('treatment', null, { reload: 'treatment' });
        		}, function() {
        			$state.go('treatment');
        		});
        	}]
        })
        .state('treatment-detail.edit', {
            parent: 'treatment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment/treatment-dialog.html',
                    controller: 'TreatmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Treatment', function(Treatment) {
                            return Treatment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('treatment.new', {
            parent: 'treatment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment/treatment-dialog.html',
                    controller: 'TreatmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fixedPrice: null,
                                minPrice: null,
                                maxPrice: null,
                                type: null,
                                duration: 30,
                                currency: 'CHF',
                                showPrice: false,
                                showDuration: false,
                                displayOnStandalone: true,
                                displayOnPlatform: true,
                                customName: null,
                                sortingOrder: null,
                                externalCalendarId: null,
                                externalCalendarData: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('treatment', null, { reload: 'treatment' });
                }, function() {
                    $state.go('treatment');
                });
            }]
        })
        .state('treatment.edit', {
            parent: 'treatment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment/treatment-dialog.html',
                    controller: 'TreatmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Treatment', function(Treatment) {
                            return Treatment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('treatment', null, { reload: 'treatment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('treatment.delete', {
            parent: 'treatment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment/treatment-delete-dialog.html',
                    controller: 'TreatmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Treatment', function(Treatment) {
                            return Treatment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('treatment', null, { reload: 'treatment' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('Treatment', Treatment);

    Treatment.$inject = ['$resource'];

    function Treatment ($resource) {
        var resourceUrl =  'api/treatments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getByPracticesOfPractitioner': {
                method: 'GET',
                isArray: true,
                url: 'api/treatments/byPracticesOfPractitioner/:practitionerId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentController', TreatmentController);

    TreatmentController.$inject = ['$scope', '$state', 'Treatment', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TreatmentController ($scope, $state, Treatment, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 500;//paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Treatment.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.treatments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('AddDefaultTreatmentsDialogController', AddDefaultTreatmentsDialogController);

    AddDefaultTreatmentsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Treatment', 'Practice', 'Coupon'];

    function AddDefaultTreatmentsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Treatment, Practice, Coupon) {
        var vm = this;

        vm.treatment = entity;
        vm.clear = clear;
        vm.save = save;
        
        vm.practices = Practice.query({size: 2000});
        vm.coupons = Coupon.query({size: 2000});
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {
        	console.log("evo me, tu sam");
        	System.out.println("evo me tu sam");
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:treatmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PractitionerDialogController', PractitionerDialogController);

    PractitionerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Practitioner', 'Treatment'];

    function PractitionerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Practitioner, Treatment) {
        var vm = this;

        vm.practitioner = entity;
        vm.clear = clear;
        vm.save = save;
        // Practitioner could have existing treatments from other practices, so we merge them with the treatments of the currently associated practices
        if (vm.practitioner.id != null) {
            Treatment.getByPracticesOfPractitioner({practitionerId: vm.practitioner.id}, function (treatmentsOfCurrentRelatedPractices) {
                var existingTreatments = vm.practitioner.treatments;
                vm.treatments = filterDuplicateElements(existingTreatments.concat(treatmentsOfCurrentRelatedPractices), function (e) { return e.id; });
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        
        function filterDuplicateElements(array, keyFunction) {
            var seen = {};
            return array.filter(function(item) {
                var k = keyFunction(item);
                return seen.hasOwnProperty(k) ? false : (seen[k] = true);
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            
            if (vm.practitioner.title === '') {
                vm.practitioner.title = null;
            }
            
            if (vm.practitioner.id !== null) {
                Practitioner.update(vm.practitioner, onSaveSuccess, onSaveError);
            } else {
                Practitioner.save(vm.practitioner, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:practitionerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PractitionerDetailController', PractitionerDetailController);

    PractitionerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Practitioner', 'Treatment'];

    function PractitionerDetailController($scope, $rootScope, $stateParams, previousState, entity, Practitioner, Treatment) {
        var vm = this;

        vm.practitioner = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:practitionerUpdate', function(event, result) {
            vm.practitioner = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PractitionerDeleteController',PractitionerDeleteController);

    PractitionerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Practitioner'];

    function PractitionerDeleteController($uibModalInstance, entity, Practitioner) {
        var vm = this;

        vm.practitioner = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Practitioner.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('practitioner', {
            parent: 'entity',
            url: '/practitioner?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.practitioner.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/practitioner/practitioners.html',
                    controller: 'PractitionerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('practitioner');
                    $translatePartialLoader.addPart('practitionerSalutation');
                    $translatePartialLoader.addPart('profession');
                    $translatePartialLoader.addPart('practice');
                    $translatePartialLoader.addPart('professionalCategory');
                    $translatePartialLoader.addPart('treatmentType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('practitioner-detail', {
            parent: 'practitioner',
            url: '/practitioner/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.practitioner.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/practitioner/practitioner-detail.html',
                    controller: 'PractitionerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('practitioner');
                    $translatePartialLoader.addPart('practitionerSalutation');
                    $translatePartialLoader.addPart('profession');
                    $translatePartialLoader.addPart('professionalCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Practitioner', function($stateParams, Practitioner) {
                    return Practitioner.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'practitioner',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('practitioner-detail.edit', {
            parent: 'practitioner-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practitioner/practitioner-dialog.html',
                    controller: 'PractitionerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Practitioner', function(Practitioner) {
                            return Practitioner.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('practitioner.new', {
            parent: 'practitioner',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practitioner/practitioner-dialog.html',
                    controller: 'PractitionerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                salutation: null,
                                firstname: null,
                                lastname: null,
                                phone: null,
                                addressStreet: null,
                                addressStreetNumber: null,
                                addressCity: null,
                                addressPostalCode: null,
                                profession: null,
                                professionalCategory: null,
                                email: null,
                                pictureUrl: null,
                                taxpunktwert: null,
                                externalCalendarId: null,
                                externalCalendarData: null,
                                bookingPictureUrl: null,
                                cvUrl: null,
                                customProfession: null,
                                sortingOrder: null,
                                hideOnProfile: null,
                                titleText: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('practitioner', null, { reload: 'practitioner' });
                }, function() {
                    $state.go('practitioner');
                });
            }]
        })
        .state('practitioner.edit', {
            parent: 'practitioner',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practitioner/practitioner-dialog.html',
                    controller: 'PractitionerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Practitioner', function(Practitioner) {
                            return Practitioner.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('practitioner', null, { reload: 'practitioner' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('practitioner.delete', {
            parent: 'practitioner',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practitioner/practitioner-delete-dialog.html',
                    controller: 'PractitionerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Practitioner', function(Practitioner) {
                            return Practitioner.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('practitioner', null, { reload: 'practitioner' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('Practitioner', Practitioner);

    Practitioner.$inject = ['$resource'];

    function Practitioner ($resource) {
        var resourceUrl =  'api/practitioners/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PractitionerController', PractitionerController);

    PractitionerController.$inject = ['$scope', '$state', 'Practitioner', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Treatment'];

    function PractitionerController ($scope, $state, Practitioner, ParseLinks, AlertService, paginationConstants, pagingParams, Treatment) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Practitioner.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.practitioners = data;
                vm.page = pagingParams.page;
                vm.practitioners.forEach(function(pract) {
                    if (pract.treatments && pract.treatments.length) {
                        var practiceNames = new Set();
                        var practiceIds = new Set();
                        pract.treatments.forEach(function(treat) { practiceNames.add(treat.practice.name); practiceIds.add(treat.practice.id); });
                        pract.practiceIds = "";
                        pract.practiceNames = "";
                        practiceNames.forEach(function(name) { pract.practiceNames += name + ","; });
                        practiceIds.forEach(function(id) { pract.practiceIds += id + ","; });
                    }
                });
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PracticeProfileDialogController', PracticeProfileDialogController);

    PracticeProfileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PracticeProfile'];

    function PracticeProfileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PracticeProfile) {
        var vm = this;

        vm.practiceProfile = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.practiceProfile.id !== null) {
                PracticeProfile.update(vm.practiceProfile, onSaveSuccess, onSaveError);
            } else {
                PracticeProfile.save(vm.practiceProfile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:practiceProfileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PracticeProfileDetailController', PracticeProfileDetailController);

    PracticeProfileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PracticeProfile'];

    function PracticeProfileDetailController($scope, $rootScope, $stateParams, previousState, entity, PracticeProfile) {
        var vm = this;

        vm.practiceProfile = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:practiceProfileUpdate', function(event, result) {
            vm.practiceProfile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PracticeProfileDeleteController',PracticeProfileDeleteController);

    PracticeProfileDeleteController.$inject = ['$uibModalInstance', 'entity', 'PracticeProfile'];

    function PracticeProfileDeleteController($uibModalInstance, entity, PracticeProfile) {
        var vm = this;

        vm.practiceProfile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PracticeProfile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('practice-profile', {
            parent: 'entity',
            url: '/practice-profile?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.practiceProfile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/practice-profile/practice-profiles.html',
                    controller: 'PracticeProfileController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('practiceProfile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('practice-profile-detail', {
            parent: 'practice-profile',
            url: '/practice-profile/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.practiceProfile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/practice-profile/practice-profile-detail.html',
                    controller: 'PracticeProfileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('practiceProfile');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PracticeProfile', function($stateParams, PracticeProfile) {
                    return PracticeProfile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'practice-profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('practice-profile-detail.edit', {
            parent: 'practice-profile-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practice-profile/practice-profile-dialog.html',
                    controller: 'PracticeProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PracticeProfile', function(PracticeProfile) {
                            return PracticeProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('practice-profile.new', {
            parent: 'practice-profile',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practice-profile/practice-profile-dialog.html',
                    controller: 'PracticeProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                location_directions: null,
                                images: null,
                                description: null,
                                welcome_message: null,
                                slogan: null,
                                taxpunktwert: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('practice-profile', null, { reload: 'practice-profile' });
                }, function() {
                    $state.go('practice-profile');
                });
            }]
        })
        .state('practice-profile.edit', {
            parent: 'practice-profile',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practice-profile/practice-profile-dialog.html',
                    controller: 'PracticeProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PracticeProfile', function(PracticeProfile) {
                            return PracticeProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('practice-profile', null, { reload: 'practice-profile' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('practice-profile.delete', {
            parent: 'practice-profile',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practice-profile/practice-profile-delete-dialog.html',
                    controller: 'PracticeProfileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PracticeProfile', function(PracticeProfile) {
                            return PracticeProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('practice-profile', null, { reload: 'practice-profile' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('PracticeProfile', PracticeProfile);

    PracticeProfile.$inject = ['$resource'];

    function PracticeProfile ($resource) {
        var resourceUrl =  'api/practice-profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PracticeProfileController', PracticeProfileController);

    PracticeProfileController.$inject = ['$scope', '$state', 'PracticeProfile', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Practice'];

    function PracticeProfileController ($scope, $state, PracticeProfile, ParseLinks, AlertService, paginationConstants, pagingParams, Practice) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        
        loadAll();

        function loadAll () {
            PracticeProfile.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.practiceProfiles = data;
                vm.page = pagingParams.page;
                
                loadPracticeNames();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        function loadPracticeNames() {
            Practice.query({
                size: 10000 // FIXME [dom] can/will not be enough; should be a new, dedicated query only getting practice.name and practice.practiceProfile.id based on vm.practiceProfiles
            }, onSuccess, onError);
            function onSuccess(response, headers) {
                
                for(var j = 0; j<vm.practiceProfiles.length;j++) {
                    for(var i = 0; i<response.length;i++) {
                        if(response[i].practiceProfile) {
                            if(vm.practiceProfiles[j].id == response[i].practiceProfile.id) {
                                vm.practiceProfiles[j].practiceName = response[i].name;
                                break;
                            }
                        }
                    }
                }

            }
            function onError(error) {
                console.log("Error in practice-profile.controller.js: ", err);
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PracticeDialogController', PracticeDialogController);

    PracticeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'DataUtils', 'entity', 'Practice', 'Calendar', 'Practitioner', 'PracticeProfile'];

    function PracticeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, DataUtils, entity, Practice, Calendar, Practitioner, PracticeProfile) {
        var vm = this;

        vm.practice = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.calendars = Calendar.query();
//        vm.practitioners = Practitioner.query();
        vm.practitioners = Practitioner.query({size: 5000});
        
        vm.practitionersString = "";
        if (vm.practice.practitioners != null) {
            vm.practice.practitioners.forEach(function(p,i) {
            	var string;
            	if (i==0) {
            		string = String(p.id);
            	} else {
            		string = ", " + String(p.id);
            	}
            	vm.practitionersString = vm.practitionersString.concat(string);
            });
        }
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	var practitionersTemp = [];
        	
            vm.isSaving = true;
            
            if(vm.practice.practiceProfile != null && vm.practice.practiceProfile.id == null) {
            	vm.practice.practiceProfile = null;
            }
            
            vm.practitonersString = vm.practitionersString.split(',').forEach(function (string, j) {
        		if(isNaN(string)) {
                	alert("Error found when parsing entered id in location "+(j+1)+"! Put only numbers (practitioner id's) between the commas!");
                	onSaveError();
        		} else {
        			for(var i = 0; i < vm.practitioners.length; i++) {
        			    if (vm.practitioners[i].id == parseInt(string)) {
        			    	practitionersTemp.push(vm.practitioners[i]);
        			    	break;
        			    } else if (i == vm.practitioners.length - 1) {
                        	alert("There is no practitioner with id: "+string+"! Saving without this one..");
        			    }
        			}
        		}
        	});
            
            if(vm.isSaving) {
            	vm.practice.practitioners = [];
            	for(var i = 0; i < practitionersTemp.length; i++) {
            		vm.practice.practitioners.push(practitionersTemp[i]);
            	}
            	
            	
            }
            
            if (vm.practice.id !== null) {
                Practice.update(vm.practice, onSaveSuccess, onSaveError);
            } else {
                Practice.save(vm.practice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:practiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setPicture = function ($file, practice) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        practice.picture = base64Data;
                        practice.pictureContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PracticeDetailController', PracticeDetailController);

    PracticeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Practice', 'Calendar', 'Practitioner', 'PracticeProfile', '$uibModal'];

    function PracticeDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Practice, Calendar, Practitioner, PracticeProfile, $uibModal) {
        var vm = this;

        vm.practice = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.showExternalCalendarInfo = showExternalCalendarInfo;
        vm.isExternalCalendar = isExternalCalendar;

        function showExternalCalendarInfo() {
            var externalCalendarInfo = Practice.getExternalCalendarInfo({id: vm.practice.id});

            $uibModal.open({
                template: '<div class="modal-body pad"><span style="white-space: pre-wrap;">{{vm.externalCalendarInfo.info}}</span></div>',
                controller: function() { var vm = this; vm.externalCalendarInfo = externalCalendarInfo; },
                controllerAs: 'vm',
                size: 'lg'
            });
        }

        function isExternalCalendar() {
            return vm.practice.calendarType !== 'ZUMEDO';
        }

        var unsubscribe = $rootScope.$on('getwellApp:practiceUpdate', function(event, result) {
            vm.practice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PracticeDeleteController',PracticeDeleteController);

    PracticeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Practice'];

    function PracticeDeleteController($uibModalInstance, entity, Practice) {
        var vm = this;

        vm.practice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Practice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('practice', {
            parent: 'entity',
            url: '/practice?page&sort&search&teaser',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.practice.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/practice/practices.html',
                    controller: 'PracticeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                teaser: 'false'
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        teaser: $stateParams.teaser
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('practice');
                    $translatePartialLoader.addPart('professionalCategory');
                    $translatePartialLoader.addPart('practiceLocation');
                    $translatePartialLoader.addPart('practiceCalendarType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('practice-detail', {
            parent: 'practice',
            url: '/practice/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.practice.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/practice/practice-detail.html',
                    controller: 'PracticeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('practice');
                    $translatePartialLoader.addPart('professionalCategory');
                    $translatePartialLoader.addPart('practiceLocation');
                    $translatePartialLoader.addPart('practiceCalendarType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Practice', function($stateParams, Practice) {
                    return Practice.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'practice',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('practice-detail.edit', {
            parent: 'practice-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practice/practice-dialog.html',
                    controller: 'PracticeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Practice', function(Practice) {
                            return Practice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('practice.new', {
            parent: 'practice',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practice/practice-dialog.html',
                    controller: 'PracticeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                phone: null,
                                fax: null,
                                addressStreet: null,
                                addressStreetNumber: null,
                                addressCity: null,
                                addressStreetMore: null,
                                addressPostalCode: null,
                                email: null,
                                professionalCategory: null,
                                networkedPracticeName: null,
                                networkedPractice: null,
                                picture: null,
                                pictureContentType: null,
                                notes: null,
                                taxpunktwert: null,
                                bookingTerms: null,
                                location: null,
                                coordinates: null,
                                showBusinessCard: false,
                                locationDescription: null,
                                profilePath: null,
                                externalCalendarId: null,
                                externalCalendarCredential: null,
                                externalCalendarData: null,
                                languages: null,
                                specializations: null,
                                teaser: null,
                                teaserData: null,
                                standaloneStyle: null,
                                calendarType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('practice', null, { reload: 'practice' });
                }, function() {
                    $state.go('practice');
                });
            }]
        })
        .state('practice.edit', {
            parent: 'practice',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practice/practice-dialog.html',
                    controller: 'PracticeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Practice', function(Practice) {
                            return Practice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('practice', null, { reload: 'practice' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('practice.delete', {
            parent: 'practice',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practice/practice-delete-dialog.html',
                    controller: 'PracticeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Practice', function(Practice) {
                            return Practice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('practice', null, { reload: 'practice' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('Practice', Practice);

    Practice.$inject = ['$resource'];

    function Practice ($resource) {
        var resourceUrl =  'api/practices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' },
            'getWithCalendars': {
                method: 'GET',
                url: 'api/practices/withCalendars/:id',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getExternalCalendarInfo': {
                method: 'GET',
                url: 'api/practices/:id/externalCalendarInfo',
                transformResponse: function (data) {
                    if (data) {
                        data = { info: data }; // transform string to JavaScript object
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PracticeController', PracticeController);

    PracticeController.$inject = ['$scope', '$state', 'DataUtils', 'Practice', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PracticeController ($scope, $state, DataUtils, Practice, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 1000;//paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        
        if (pagingParams.teaser == "true") {
        	vm.teaser = true;
        } else {
        	vm.teaser = false;
        }

        loadAll();

        function loadAll () {
            Practice.query({
                page: pagingParams.page - 1,
                teaser: vm.teaser,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.practices = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                teaser: vm.teaser,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('EndCustomerDialogController', EndCustomerDialogController);

    EndCustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EndCustomer'];

    function EndCustomerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EndCustomer) {
        var vm = this;

        vm.endCustomer = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.endCustomer.id !== null) {
                EndCustomer.update(vm.endCustomer, onSaveSuccess, onSaveError);
            } else {
                EndCustomer.save(vm.endCustomer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:endCustomerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateOfBirth = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('EndCustomerDetailController', EndCustomerDetailController);

    EndCustomerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'EndCustomer'];

    function EndCustomerDetailController($scope, $rootScope, $stateParams, previousState, entity, EndCustomer) {
        var vm = this;

        vm.endCustomer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:endCustomerUpdate', function(event, result) {
            vm.endCustomer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('EndCustomerDeleteController',EndCustomerDeleteController);

    EndCustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'EndCustomer'];

    function EndCustomerDeleteController($uibModalInstance, entity, EndCustomer) {
        var vm = this;

        vm.endCustomer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EndCustomer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('end-customer', {
            parent: 'entity',
            url: '/end-customer?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.endCustomer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/end-customer/end-customers.html',
                    controller: 'EndCustomerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('endCustomer');
                    $translatePartialLoader.addPart('practitionerSalutation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('end-customer-detail', {
            parent: 'end-customer',
            url: '/end-customer/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.endCustomer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/end-customer/end-customer-detail.html',
                    controller: 'EndCustomerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('endCustomer');
                    $translatePartialLoader.addPart('practitionerSalutation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EndCustomer', function($stateParams, EndCustomer) {
                    return EndCustomer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'end-customer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('end-customer-detail.edit', {
            parent: 'end-customer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/end-customer/end-customer-dialog.html',
                    controller: 'EndCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EndCustomer', function(EndCustomer) {
                            return EndCustomer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('end-customer.new', {
            parent: 'end-customer',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/end-customer/end-customer-dialog.html',
                    controller: 'EndCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstname: null,
                                lastname: null,
                                phone: null,
                                salutation: null,
                                addressStreet: null,
                                addressStreetNumber: null,
                                addressCity: null,
                                addressPostalCode: null,
                                email: null,
                                dateOfBirth: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('end-customer', null, { reload: 'end-customer' });
                }, function() {
                    $state.go('end-customer');
                });
            }]
        })
        .state('end-customer.edit', {
            parent: 'end-customer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/end-customer/end-customer-dialog.html',
                    controller: 'EndCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EndCustomer', function(EndCustomer) {
                            return EndCustomer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('end-customer', null, { reload: 'end-customer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('end-customer.delete', {
            parent: 'end-customer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/end-customer/end-customer-delete-dialog.html',
                    controller: 'EndCustomerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EndCustomer', function(EndCustomer) {
                            return EndCustomer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('end-customer', null, { reload: 'end-customer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('EndCustomer', EndCustomer);

    EndCustomer.$inject = ['$resource', 'DateUtils'];

    function EndCustomer ($resource, DateUtils) {
        var resourceUrl =  'api/end-customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateOfBirth = DateUtils.convertLocalDateFromServer(data.dateOfBirth);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfBirth = DateUtils.convertLocalDateToServer(copy.dateOfBirth);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfBirth = DateUtils.convertLocalDateToServer(copy.dateOfBirth);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('EndCustomerController', EndCustomerController);

    EndCustomerController.$inject = ['$scope', '$state', 'EndCustomer', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function EndCustomerController ($scope, $state, EndCustomer, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            EndCustomer.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.endCustomers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('CouponDialogController', CouponDialogController);

    CouponDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Coupon'];

    function CouponDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Coupon) {
        var vm = this;

        vm.coupon = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.coupon.id !== null) {
                Coupon.update(vm.coupon, onSaveSuccess, onSaveError);
            } else {
                Coupon.save(vm.coupon, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:couponUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('CouponDetailController', CouponDetailController);

    CouponDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Coupon'];

    function CouponDetailController($scope, $rootScope, $stateParams, previousState, entity, Coupon) {
        var vm = this;

        vm.coupon = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:couponUpdate', function(event, result) {
            vm.coupon = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('CouponDeleteController',CouponDeleteController);

    CouponDeleteController.$inject = ['$uibModalInstance', 'entity', 'Coupon'];

    function CouponDeleteController($uibModalInstance, entity, Coupon) {
        var vm = this;

        vm.coupon = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Coupon.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('coupon', {
            parent: 'entity',
            url: '/coupon?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.coupon.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/coupon/coupons.html',
                    controller: 'CouponController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('coupon');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('coupon-detail', {
            parent: 'coupon',
            url: '/coupon/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.coupon.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/coupon/coupon-detail.html',
                    controller: 'CouponDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('coupon');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Coupon', function($stateParams, Coupon) {
                    return Coupon.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'coupon',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('coupon-detail.edit', {
            parent: 'coupon-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/coupon/coupon-dialog.html',
                    controller: 'CouponDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Coupon', function(Coupon) {
                            return Coupon.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('coupon.new', {
            parent: 'coupon',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/coupon/coupon-dialog.html',
                    controller: 'CouponDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                isPercentage: false,
                                value: null,
                                isActive: false,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('coupon', null, { reload: 'coupon' });
                }, function() {
                    $state.go('coupon');
                });
            }]
        })
        .state('coupon.edit', {
            parent: 'coupon',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/coupon/coupon-dialog.html',
                    controller: 'CouponDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Coupon', function(Coupon) {
                            return Coupon.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('coupon', null, { reload: 'coupon' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('coupon.delete', {
            parent: 'coupon',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/coupon/coupon-delete-dialog.html',
                    controller: 'CouponDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Coupon', function(Coupon) {
                            return Coupon.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('coupon', null, { reload: 'coupon' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('Coupon', Coupon);

    Coupon.$inject = ['$resource'];

    function Coupon ($resource) {
        var resourceUrl =  'api/coupons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('CouponController', CouponController);

    CouponController.$inject = ['$scope', '$state', 'Coupon', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CouponController ($scope, $state, Coupon, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Coupon.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.coupons = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('CalendarDialogController', CalendarDialogController);

    CalendarDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Calendar', 'Practice', 'Practitioner'];

    function CalendarDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Calendar, Practice, Practitioner) {
        var vm = this;

        vm.calendar = entity;
        vm.clear = clear;
        vm.save = save;
        // FIXME [dom] change implementation here such that only the id (and not the whole practice or practitioner object) is used 
//        vm.practices = Practice.query();
//        vm.practitioners = Practitioner.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {
            vm.isSaving = true;
            
            if(vm.calendar.practitioner != null && vm.calendar.practitioner.id == null) {
            		vm.calendar.practitioner = null;
            }
            
            if(vm.calendar.practitioner != null) {
            	if((vm.calendar.practitioner.id == null && vm.calendar.type == "RESOURCE") || (vm.calendar.practitioner.id != null && vm.calendar.type == "PERSON")) {
		        	if (vm.calendar.id !== null) {
		                Calendar.update(vm.calendar, onSaveSuccess, onSaveError);
		            } else  {
		                Calendar.save(vm.calendar, onSaveSuccess, onSaveError);
		            } 
		        } else {
		        	onSaveError();
		        	if(vm.calendar.practitioner.id != null && vm.calendar.type == "RESOURCE") {
		        		alert("For the type 'RESOURCE' there should NOT be a practitioner id set..");
		        	} else if(vm.calendar.practitioner.id == null && vm.calendar.type == "PERSON") {
		        		alert("For the type 'PERSON' there should be a practitioner id set..");		        		
		        	} else {
		        		alert("Check input fields please.");
		        	}
		        }
            } else if(vm.calendar.type == "RESOURCE") {
            	if (vm.calendar.id !== null) {
	                Calendar.update(vm.calendar, onSaveSuccess, onSaveError);
	            } else  {
	                Calendar.save(vm.calendar, onSaveSuccess, onSaveError);
	            } 
            } else {
	        	onSaveError();
        		alert("For the type 'PERSON' there should be a practitioner id set..");	
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:calendarUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('CalendarDetailController', CalendarDetailController);

    CalendarDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Calendar', 'Practice', 'Practitioner'];

    function CalendarDetailController($scope, $rootScope, $stateParams, previousState, entity, Calendar, Practice, Practitioner) {
        var vm = this;

        vm.calendar = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:calendarUpdate', function(event, result) {
            vm.calendar = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('CalendarDeleteController',CalendarDeleteController);

    CalendarDeleteController.$inject = ['$uibModalInstance', 'entity', 'Calendar'];

    function CalendarDeleteController($uibModalInstance, entity, Calendar) {
        var vm = this;

        vm.calendar = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Calendar.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('calendar', {
            parent: 'entity',
            url: '/calendarEntity?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.calendar.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/calendar/calendars.html',
                    controller: 'CalendarController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('calendar');
                    $translatePartialLoader.addPart('calendarType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('calendar-detail', {
            parent: 'calendar',
            url: '/calendarEntity/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.calendar.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/calendar/calendar-detail.html',
                    controller: 'CalendarDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('calendar');
                    $translatePartialLoader.addPart('calendarType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Calendar', function($stateParams, Calendar) {
                    return Calendar.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'calendar',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('calendar-detail.edit', {
            parent: 'calendar-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/calendar-dialog.html',
                    controller: 'CalendarDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Calendar', function(Calendar) {
                            return Calendar.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('calendar.new', {
            parent: 'calendar',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/calendar-dialog.html',
                    controller: 'CalendarDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                freeSlotsBookable: false,
                                type: null,
                                defaultRelatedCalendarId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('calendar', null, { reload: 'calendar' });
                }, function() {
                    $state.go('calendar');
                });
            }]
        })
        .state('calendar.edit', {
            parent: 'calendar',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/calendar-dialog.html',
                    controller: 'CalendarDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Calendar', function(Calendar) {
                            return Calendar.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('calendar', null, { reload: 'calendar' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('calendar.delete', {
            parent: 'calendar',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/calendar-delete-dialog.html',
                    controller: 'CalendarDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Calendar', function(Calendar) {
                            return Calendar.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('calendar', null, { reload: 'calendar' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('Calendar', Calendar);

    Calendar.$inject = ['$resource'];

    function Calendar ($resource) {
        var resourceUrl =  'api/calendars/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('CalendarController', CalendarController);

    CalendarController.$inject = ['$scope', '$state', 'Calendar', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CalendarController ($scope, $state, Calendar, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Calendar.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.calendars = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('BookingDialogController', BookingDialogController);

    BookingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Booking', 'EndCustomer', 'Treatment', 'Coupon', 'Practitioner'];

    function BookingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Booking, EndCustomer, Treatment, Coupon, Practitioner) {
        var vm = this;

        vm.booking = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        // TODO [dom] change implementation here such that only the id (and not the whole endcustomer or treatment object) is used
//        vm.endcustomers = EndCustomer.query();
//        vm.treatments = Treatment.query();
//        vm.practitioners = Practitioner.query();
        vm.coupons = Coupon.query({size: 100});
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            
            if (vm.booking.appointmentChange === '') {
            	vm.booking.appointmentChange = null;
            }
            
            if (vm.booking.id !== null) {
                Booking.update(vm.booking, onSaveSuccess, onSaveError);
            } else {
                Booking.save(vm.booking, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:bookingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.bookingTime = false;
        vm.datePickerOpenStatus.appointmentStartTime = false;
        vm.datePickerOpenStatus.appointmentEndTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('BookingDetailController', BookingDetailController);

    BookingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Booking', 'EndCustomer', 'Treatment', 'Coupon', 'Practitioner'];

    function BookingDetailController($scope, $rootScope, $stateParams, previousState, entity, Booking, EndCustomer, Treatment, Coupon, Practitioner) {
        var vm = this;

        vm.booking = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:bookingUpdate', function(event, result) {
            vm.booking = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('BookingDeleteController',BookingDeleteController);

    BookingDeleteController.$inject = ['$uibModalInstance', 'entity', 'Booking'];

    function BookingDeleteController($uibModalInstance, entity, Booking) {
        var vm = this;

        vm.booking = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Booking.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('booking', {
            parent: 'entity',
            url: '/booking?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.booking.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/booking/bookings.html',
                    controller: 'BookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('bookingType');
                    $translatePartialLoader.addPart('appointmentChange');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('booking-detail', {
            parent: 'booking',
            url: '/booking/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.booking.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/booking/booking-detail.html',
                    controller: 'BookingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('bookingType');
                    $translatePartialLoader.addPart('appointmentChange');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Booking', function($stateParams, Booking) {
                    return Booking.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'booking',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('booking-detail.edit', {
            parent: 'booking-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/booking/booking-dialog.html',
                    controller: 'BookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Booking', function(Booking) {
                            return Booking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('booking.new', {
            parent: 'booking',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/booking/booking-dialog.html',
                    controller: 'BookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                bookingTime: null,
                                termsAccepted: false,
                                appointmentStartTime: null,
                                appointmentEndTime: null,
                                reference: null,
                                initialPrice: null,
                                finalPrice: null,
                                comment: null,
                                adminNotes: null,
                                couponCode: null,
                                type: null,
                                appointmentChange: null,
                                customName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('booking', null, { reload: 'booking' });
                }, function() {
                    $state.go('booking');
                });
            }]
        })
        .state('booking.edit', {
            parent: 'booking',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/booking/booking-dialog.html',
                    controller: 'BookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Booking', function(Booking) {
                            return Booking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('booking', null, { reload: 'booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('booking.delete', {
            parent: 'booking',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/booking/booking-delete-dialog.html',
                    controller: 'BookingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Booking', function(Booking) {
                            return Booking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('booking', null, { reload: 'booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('Booking', Booking);

    Booking.$inject = ['$resource', 'DateUtils'];

    function Booking ($resource, DateUtils) {
        var resourceUrl =  'api/bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.bookingTime = DateUtils.convertDateTimeFromServer(data.bookingTime);
                        data.appointmentStartTime = DateUtils.convertDateTimeFromServer(data.appointmentStartTime);
                        data.appointmentEndTime = DateUtils.convertDateTimeFromServer(data.appointmentEndTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('BookingController', BookingController);

    BookingController.$inject = ['$scope', '$state', 'Booking', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function BookingController ($scope, $state, Booking, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Booking.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bookings = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('getwellApp')
        .factory('Appointment', Appointment);

    Appointment.$inject = ['$resource', 'DateUtils'];

    function Appointment ($resource, DateUtils) {
        var resourceUrl =  'api/appointments/:id';

        return $resource(resourceUrl, {}, {
            'query': {
            	method: 'GET',
            	isArray: true,
            	url: 'api/appointments/calendar/:calendarId',
            	transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        // convert string to date object
                        data.forEach(function(entry) {
                        	entry.start_date = DateUtils.convertDateTimeFromServer(entry.start_date);
                        	entry.end_date = DateUtils.convertDateTimeFromServer(entry.end_date);
                        	
                        });
                    }
                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
//                        data.startTime = DateUtils.convertDateTimeFromServer(data.startTime);
                        data.start_date = DateUtils.convertDateTimeFromServer(data.start_date);
                        data.end_date = DateUtils.convertDateTimeFromServer(data.end_date);
//                        data.endTime = DateUtils.convertDateTimeFromServer(data.endTime);
                    }
                    return data;
                }
            },
            'update': {
            	method:'PUT',
            	transformRequest: function (data) {
        			// sometimes, scheduler converts Arrays to Strings and we must convert them back
        			if (typeof data.personCalendarIds === "string") {
        				data.personCalendarIds = data.personCalendarIds.split(",");
        			}
        			if (typeof data.resourceCalendarIds === "string") {
        				data.resourceCalendarIds = data.resourceCalendarIds.split(",");
        			}
        			data = angular.toJson(data);
        			return data;
            	}
            },
            'save': {
            	method:'POST',
        		transformRequest: function (data) {
        			// sometimes, scheduler converts Arrays to Strings and we must convert them back
        			if (typeof data.personCalendarIds === "string") {
        				data.personCalendarIds = data.personCalendarIds.split(",");
        			}
        			if (typeof data.resourceCalendarIds === "string") {
        				data.resourceCalendarIds = data.resourceCalendarIds.split(",");
        			}
        			data = angular.toJson(data);
        			return data;
        		}
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('getwellApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('getwellApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('getwellApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('getwellApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('getwellApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('getwellApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'de',
            'en',
            'fr',
            'it'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .constant('paginationConstants', {
            'itemsPerPage': 100
        });
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('getwellApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('getwellApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('getwellApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('getwellApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('bookingOld', {
            parent: 'app',
            url: '/booking/dentist/:practice',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/booking/booking.html',
                    controller: 'BookingControllerOld',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('booking');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('BookingControllerOld', BookingControllerOld);

    BookingControllerOld.$inject = ['$scope', 'ServiceType', '$stateParams'];

    function BookingControllerOld ($scope, ServiceType, $stateParams) {
        var vm = this;
        
        vm.practice = $stateParams.practice;
        
//        vm.services = [{
//        	name: "Dentalhygiene - 60 min"
//        }, {
//        	name: "Kontrolle - 15 min"
//        }, {
//        	name: "Wurzelbehandlung - 2 h"
//        }];
        
        vm.services = ServiceType.query(function(result) {
        	// TODO [dom] really necessary?
            vm.services = result;
        });
        
        vm.selectedService = null;
        
        vm.images = [{
        	name: "Dr. med. Star",
        	url: "../content/images/Doc1.png"
        }, {
        	name: "Dr. med. Guru",
        	url: "../content/images/Doc2.png"
        }];
        
        vm.showCalendar = showCalendar;
        
        function showCalendar(name) {
        	console.log("showing calendar for: " + name);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('getwellApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('getwellApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "de"');
                $cookies.putObject(name, 'de');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('de');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('getwellApp')
        .constant('VERSION', "1.6.1")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PRACTICE'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null, practice: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/user/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-tracker', {
            parent: 'admin',
            url: '/tracker',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tracker.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/tracker/tracker.html',
                    controller: 'JhiTrackerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tracker');
                    return $translate.refresh();
                }]
            },
            onEnter: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.subscribe();
            }],
            onExit: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.unsubscribe();
            }]
        });
    }
})();

(function() {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('getwellApp')
        .factory('JhiTrackerService', JhiTrackerService);

    JhiTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q'];

    function JhiTrackerService ($rootScope, $window, $cookies, $http, $q) {
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect () {
            //building absolute path so that websocket doesnt fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/tracker';
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            var stateChangeStart;
            var headers = {};
            headers[$http.defaults.xsrfHeaderName] = $cookies.get($http.defaults.xsrfCookieName);
            stompClient.connect(headers, function() {
                connected.resolve('success');
                sendActivity();
                if (!alreadyConnectedOnce) {
                    stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                        sendActivity();
                    });
                    alreadyConnectedOnce = true;
                }
            });
            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
            });
        }

        function disconnect () {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive () {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/activity',
                    {},
                    angular.toJson({'page': $rootScope.toState.name}));
            }
        }

        function subscribe () {
            connected.promise.then(function() {
                subscriber = stompClient.subscribe('/topic/tracker', function(data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe () {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('getwellApp')
        .controller('JhiTrackerController', JhiTrackerController);

    JhiTrackerController.$inject = ['$cookies', '$http', 'JhiTrackerService'];

    function JhiTrackerController ($cookies, $http, JhiTrackerService) {
        // This controller uses a Websocket connection to receive user activities in real-time.
        var vm = this;

        vm.activities = [];

        JhiTrackerService.receive().then(null, null, function(activity) {
            showActivity(activity);
        });

        function showActivity(activity) {
            var existingActivity = false;
            for (var index = 0; index < vm.activities.length; index++) {
                if(vm.activities[index].sessionId === activity.sessionId) {
                    existingActivity = true;
                    if (activity.page === 'logout') {
                        vm.activities.splice(index, 1);
                    } else {
                        vm.activities[index] = activity;
                    }
                }
            }
            if (!existingActivity && (activity.page !== 'logout')) {
                vm.activities.push(activity);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('getwellApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('getwellApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('getwellApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/blocks/home.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="home.title">Welcome, Java Hipster!</h1><p class="lead" data-translate="home.subtitle">This is your homepage</p><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div><div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div><div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" ui-sref="register">Register a new account</a></div></div><p data-translate="home.question">If you have any question on JHipster:</p><ul><li><a href="http://jhipster.github.io/" target="_blank" data-translate="home.link.homepage">JHipster homepage</a></li><li><a href="http://stackoverflow.com/tags/jhipster/info" target="_blank" data-translate="home.link.stackoverflow">JHipster on Stack Overflow</a></li><li><a href="https://github.com/jhipster/generator-jhipster/issues?state=open" target="_blank" data-translate="home.link.bugtracker">JHipster bug tracker</a></li><li><a href="https://gitter.im/jhipster/generator-jhipster" target="_blank" data-translate="home.link.chat">JHipster public chat room</a></li><li><a href="https://twitter.com/java_hipster" target="_blank" data-translate="home.link.follow">follow @java_hipster on Twitter</a></li></ul><p><span data-translate="home.like">If you like JHipster, don\'t forget to give us a star on </span>&nbsp;<a href="https://github.com/jhipster/generator-jhipster" target="_blank" data-translate="home.github">Github</a>!</p></div></div></div>');
$templateCache.put('app/booking/booking.html','<div ng-cloak><div class="row"><div class="col-md-12"><p>Seiteninhalt ersetzen durch Werte von Praxis: <b>{{vm.practice}}</b></p><h1>Praxis Dr. med. Pascalolo</h1><p>Hier kommt die Wizard-Fortschrittsanzeige</p><div><p class="lead" data-translate="booking.service">Choose your medical service:</p><select ng-model="vm.selectedService" ng-options="service as service.name for service in vm.services"></select><p class="lead" data-translate="booking.provider">Choose your service provider:</p><div class="row"><div class="col-md-2" ng-repeat="image in vm.images" ng-click="vm.showCalendar(image.name)"><img ng-src="{{image.url}}" alt="{{image.name}}" class="gallery-image"><p>{{image.name}}</p></div></div><p class="lead" data-translate="booking.date">Choose your desired date and time:</p></div></div></div></div>');
$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-4"><h1 data-translate="home.title">Willkommen.</h1><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div><div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.authenticated" translate-compile>Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><!--                 <div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.register" translate-compile> --><!--                     You don\'t have an account yet? <a class="alert-link" ui-sref="register">Register a new account</a> --><!--                 </div> --></div></div></div></div>');
$templateCache.put('app/scheduler/scheduler.html','<div ng-cloak><p><!-- \t\tKalender f&uuml;r Praxis mit Id: <b>{{vm.practiceId}}</b> --></p><!-- \t<jhi-alert></jhi-alert> --><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-12"><div class="btn-toolbar"><div class="btn-group"><label ng-repeat="resourceCalendar in vm.practice.resourceCalendars" class="btn btn-default" ng-change="vm.updateCalendar()" ng-model="vm.selectedCalendar" uib-btn-radio="{{resourceCalendar.id}}">{{resourceCalendar.name}}</label></div><div class="btn-group"><label ng-repeat="personCalendar in vm.practice.personCalendars" class="btn btn-default" ng-change="vm.updateCalendar()" ng-model="vm.selectedCalendar" uib-btn-radio="{{personCalendar.id}}">{{personCalendar.name}}</label></div></div></div><div class="col-md-12"><!-- \t<p class="lead" data-translate="booking.date">Choose your desired date and time:</p> --><div id="scheduler-1" class="dhx_cal_container" style="width:100%; height:80vh"><!-- style=\'width:1200px; height:800px; padding:10px;\' > --><div class="dhx_cal_navline"><div class="dhx_cal_prev_button">&nbsp;</div><div class="dhx_cal_next_button">&nbsp;</div><div class="dhx_cal_today_button"></div><div class="dhx_cal_date"></div><div class="dhx_cal_tab" name="day_tab" style="right: 204px"></div><!-- style="right: 204px;"></div> --><div class="dhx_cal_tab" name="week_tab"></div><!-- style="right: 140px;"></div> --><div class="dhx_cal_tab" name="month_tab"></div><!-- style="right: 76px;" ></div> --><div class="dhx_cal_tab" name="fullweek_tab" style="right: 280px"></div></div><div class="dhx_cal_header"></div><div class="dhx_cal_data"></div></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/tracker/tracker.html','<div><h2 data-translate="tracker.title">Real-time user activities</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="tracker.table.userlogin">User</th><th data-translate="tracker.table.ipaddress">IP Address</th><th data-translate="tracker.table.page">Current page</th><th data-translate="tracker.table.time">Time</th><th></th></tr></thead><tbody><tr ng-repeat="activity in vm.activities"><td>{{activity.userLogin}}</td><td>{{activity.ipAddress}}</td><td>{{activity.page}}</td><td>{{activity.time}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="row jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span>Reset Key</span></dt><dd>{{vm.user.resetKey}}</dd><dt><span data-translate="userManagement.practice">Practice</span></dt><dd>{{vm.user.practice}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label class="control-label" data-translate="userManagement.practice" for="field_practice">Practice</label><input type="number" class="form-control" id="field_practice" name="practice" ng-model="vm.user.practice"></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="practice"><span data-translate="userManagement.practice">Practice</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger hand" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success hand" ng-click="vm.setActive(user, false)" ng-show="user.activated" data-translate="userManagement.activated">Activated</span></td><td>{{user.langKey}}</td><td>{{user.practice}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><!--             <div class="alert alert-warning"> --><!--                 <a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a> --><!--             </div> --><!--             <div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile> --><!--                 You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a> --><!--             </div> --></div></div></div>');
$templateCache.put('app/entities/booking/booking-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.booking.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="getwellApp.booking.delete.question" translate-values="{id: \'{{vm.booking.id}}\'}">Are you sure you want to delete this Booking?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/booking/booking-detail.html','<div><h2><span data-translate="getwellApp.booking.detail.title">Booking</span> {{vm.booking.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="getwellApp.booking.bookingTime">Booking Time</span></dt><dd><span>{{vm.booking.bookingTime | date:\'medium\'}}</span></dd><dt><span data-translate="getwellApp.booking.termsAccepted">Terms Accepted</span></dt><dd><span>{{vm.booking.termsAccepted}}</span></dd><dt><span data-translate="getwellApp.booking.appointmentStartTime">Appointment Start Time</span></dt><dd><span>{{vm.booking.appointmentStartTime | date:\'medium\'}}</span></dd><dt><span data-translate="getwellApp.booking.appointmentEndTime">Appointment End Time</span></dt><dd><span>{{vm.booking.appointmentEndTime | date:\'medium\'}}</span></dd><dt><span data-translate="getwellApp.booking.reference">Reference</span></dt><dd><span>{{vm.booking.reference}}</span></dd><dt><span data-translate="getwellApp.booking.initialPrice">Initial Price</span></dt><dd><span>{{vm.booking.initialPrice}}</span></dd><dt><span data-translate="getwellApp.booking.finalPrice">Final Price</span></dt><dd><span>{{vm.booking.finalPrice}}</span></dd><dt><span data-translate="getwellApp.booking.comment">Comment</span></dt><dd><span>{{vm.booking.comment}}</span></dd><dt><span data-translate="getwellApp.booking.adminNotes">Admin Notes</span></dt><dd><span style="white-space: pre-wrap">{{vm.booking.adminNotes}}</span></dd><dt><span data-translate="getwellApp.booking.couponCode">Coupon Code</span></dt><dd><span>{{vm.booking.couponCode}}</span></dd><dt><span data-translate="getwellApp.booking.type">Type</span></dt><dd><span data-translate="{{\'getwellApp.BookingType.\' + vm.booking.type}}">{{vm.booking.type}}</span></dd><dt><span data-translate="getwellApp.booking.appointmentChange">Appointment Change</span></dt><dd><span data-translate="{{\'getwellApp.AppointmentChange.\' + vm.booking.appointmentChange}}">{{vm.booking.appointmentChange}}</span></dd><dt><span data-translate="getwellApp.booking.customName">Custom Name</span></dt><dd><span>{{vm.booking.customName}}</span></dd><dt><span data-translate="getwellApp.booking.endCustomer">End Customer</span></dt><dd><a ui-sref="end-customer-detail({id:vm.booking.endCustomer.id})">{{vm.booking.endCustomer.id}}</a></dd><dt><span data-translate="getwellApp.booking.treatment">Treatment</span></dt><dd><a ui-sref="treatment-detail({id:vm.booking.treatment.id})">{{vm.booking.treatment.type}}</a></dd><dt><span data-translate="getwellApp.booking.coupon">Coupon</span></dt><dd><a ui-sref="coupon-detail({id:vm.booking.coupon.id})">{{vm.booking.coupon.code}}</a></dd><dt><span data-translate="getwellApp.booking.practitioner">Practitioner</span></dt><dd><a ui-sref="practitioner-detail({id:vm.booking.practitioner.id})">{{vm.booking.practitioner.lastname}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="booking-detail.edit({id:vm.booking.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/booking/booking-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBookingLabel" data-translate="getwellApp.booking.home.createOrEditLabel">Create or edit a Booking</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.booking.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.booking.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.bookingTime" for="field_bookingTime">Booking Time</label><div class="input-group"><input id="field_bookingTime" type="text" class="form-control" name="bookingTime" datetime-picker="{{dateformat}}" ng-model="vm.booking.bookingTime" is-open="vm.datePickerOpenStatus.bookingTime" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'bookingTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.bookingTime.$invalid"><p class="help-block" ng-show="editForm.bookingTime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.bookingTime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.termsAccepted" for="field_termsAccepted">Terms Accepted</label><input type="checkbox" class="form-control" name="termsAccepted" id="field_termsAccepted" ng-model="vm.booking.termsAccepted"><div ng-show="editForm.termsAccepted.$invalid"><p class="help-block" ng-show="editForm.termsAccepted.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.appointmentStartTime" for="field_appointmentStartTime">Appointment Start Time</label><div class="input-group"><input id="field_appointmentStartTime" type="text" class="form-control" name="appointmentStartTime" datetime-picker="{{dateformat}}" ng-model="vm.booking.appointmentStartTime" is-open="vm.datePickerOpenStatus.appointmentStartTime" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'appointmentStartTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.appointmentStartTime.$invalid"><p class="help-block" ng-show="editForm.appointmentStartTime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.appointmentStartTime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.appointmentEndTime" for="field_appointmentEndTime">Appointment End Time</label><div class="input-group"><input id="field_appointmentEndTime" type="text" class="form-control" name="appointmentEndTime" datetime-picker="{{dateformat}}" ng-model="vm.booking.appointmentEndTime" is-open="vm.datePickerOpenStatus.appointmentEndTime" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'appointmentEndTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.appointmentEndTime.$invalid"><p class="help-block" ng-show="editForm.appointmentEndTime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.appointmentEndTime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.reference" for="field_reference">Reference</label><input type="text" class="form-control" name="reference" id="field_reference" ng-model="vm.booking.reference" required ng-maxlength="6"><div ng-show="editForm.reference.$invalid"><p class="help-block" ng-show="editForm.reference.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.reference.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="6">This field cannot be longer than 6 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.initialPrice" for="field_initialPrice">Initial Price</label><input type="number" class="form-control" name="initialPrice" id="field_initialPrice" ng-model="vm.booking.initialPrice"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.finalPrice" for="field_finalPrice">Final Price</label><input type="number" class="form-control" name="finalPrice" id="field_finalPrice" ng-model="vm.booking.finalPrice"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.booking.comment" ng-maxlength="2000"><div ng-show="editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2000">This field cannot be longer than 2000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.adminNotes" for="field_adminNotes">Admin Notes</label><textarea class="form-control" name="adminNotes" id="field_adminNotes" ng-model="vm.booking.adminNotes" ng-maxlength="2000"></textarea><div ng-show="editForm.adminNotes.$invalid"><p class="help-block" ng-show="editForm.adminNotes.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2000">This field cannot be longer than 2000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.couponCode" for="field_couponCode">Coupon Code</label><input type="text" class="form-control" name="couponCode" id="field_couponCode" ng-model="vm.booking.couponCode" ng-maxlength="50"><div ng-show="editForm.couponCode.$invalid"><p class="help-block" ng-show="editForm.couponCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.booking.type" id="field_type" required><option value="" hidden><option value="BOOKING" data-translate="getwellApp.BookingType.BOOKING" selected="selected">BOOKING</option><option value="KOVO" data-translate="getwellApp.BookingType.KOVO">KOVO</option><option value="KOVO_BIG" data-translate="getwellApp.BookingType.KOVO_BIG">KOVO_BIG</option><option value="STANDALONE" data-translate="getwellApp.BookingType.STANDALONE">STANDALONE</option><option value="EXISTING_PATIENT" data-translate="getwellApp.BookingType.EXISTING_PATIENT">EXISTING_PATIENT</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.appointmentChange" for="field_appointmentChange">Appointment Change</label><select class="form-control" name="appointmentChange" ng-model="vm.booking.appointmentChange" id="field_appointmentChange"><option value=""></option><option value="VERSCHOBEN_P" data-translate="getwellApp.AppointmentChange.VERSCHOBEN_P">VERSCHOBEN_P</option><option value="VERSCHOBEN_Z" data-translate="getwellApp.AppointmentChange.VERSCHOBEN_Z">VERSCHOBEN_Z</option><option value="STORNIERT_P" data-translate="getwellApp.AppointmentChange.STORNIERT_P">STORNIERT_P</option><option value="STORNIERT_Z" data-translate="getwellApp.AppointmentChange.STORNIERT_Z">STORNIERT_Z</option><option value="NICHT_ERSCHIENEN" data-translate="getwellApp.AppointmentChange.NICHT_ERSCHIENEN">NICHT_ERSCHIENEN</option></select></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.customName" for="field_customName">Custom Name</label><input type="text" class="form-control" name="customName" id="field_customName" ng-model="vm.booking.customName" ng-maxlength="50"><div ng-show="editForm.customName.$invalid"><p class="help-block" ng-show="editForm.customName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.endCustomer" for="field_endCustomer">End Customer</label><input type="number" class="form-control" id="field_endCustomer" name="endCustomer" ng-model="vm.booking.endCustomer.id" required></div><div ng-show="editForm.endCustomer.$invalid"><p class="help-block" ng-show="editForm.endCustomer.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.treatment" for="field_treatment">Treatment</label><input type="number" class="form-control" id="field_treatment" name="treatment" ng-model="vm.booking.treatment.id" required></div><div ng-show="editForm.treatment.$invalid"><p class="help-block" ng-show="editForm.treatment.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="getwellApp.booking.coupon" for="field_coupon">Coupon</label><select class="form-control" id="field_coupon" name="coupon" ng-model="vm.booking.coupon" ng-options="coupon as coupon.code for coupon in vm.coupons track by coupon.id"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="getwellApp.booking.practitioner" for="field_practitioner">Practitioner</label><input type="number" class="form-control" id="field_practitioner" name="practitioner" ng-model="vm.booking.practitioner.id" required></div><div ng-show="editForm.practitioner.$invalid"><p class="help-block" ng-show="editForm.practitioner.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/booking/bookings.html','<div><h2 data-translate="getwellApp.booking.home.title">Bookings</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="booking.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="getwellApp.booking.home.createLabel">Create new Booking</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bookingTime"><span data-translate="getwellApp.booking.bookingTime">Booking Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="termsAccepted"><span data-translate="getwellApp.booking.termsAccepted">Terms Accepted</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="appointmentStartTime"><span data-translate="getwellApp.booking.appointmentStartTime">Appointment Start Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="appointmentEndTime"><span data-translate="getwellApp.booking.appointmentEndTime">Appointment End Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="reference"><span data-translate="getwellApp.booking.reference">Reference</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="initialPrice"><span data-translate="getwellApp.booking.initialPrice">Initial Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="finalPrice"><span data-translate="getwellApp.booking.finalPrice">Final Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="getwellApp.booking.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="adminNotes"><span data-translate="getwellApp.booking.adminNotes">Admin Notes</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="couponCode"><span data-translate="getwellApp.booking.couponCode">Coupon Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="getwellApp.booking.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="appointmentChange"><span data-translate="getwellApp.booking.appointmentChange">Appointment Change</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="customName"><span data-translate="getwellApp.booking.customName">Custom Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="endCustomer.id"><span data-translate="getwellApp.booking.endCustomer">End Customer</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="treatment.type"><span data-translate="getwellApp.booking.treatment">Treatment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="treatment.practice.name"><span data-translate="getwellApp.booking.practice">Practice</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="treatment.practice.id"><span data-translate="getwellApp.booking.practice">Practice Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="coupon.code"><span data-translate="getwellApp.booking.coupon">Coupon</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="practitioner.lastname"><span data-translate="getwellApp.booking.practitioner">Practitioner</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="booking in vm.bookings track by booking.id"><td><a ui-sref="booking-detail({id:booking.id})">{{booking.id}}</a></td><td>{{booking.bookingTime | date:\'medium\'}}</td><td>{{booking.termsAccepted}}</td><td>{{booking.appointmentStartTime | date:\'medium\'}}</td><td>{{booking.appointmentEndTime | date:\'medium\'}}</td><td>{{booking.reference}}</td><td>{{booking.initialPrice}}</td><td>{{booking.finalPrice}}</td><td>{{booking.comment}}</td><td>{{booking.adminNotes}}</td><td>{{booking.couponCode}}</td><td data-translate="{{\'getwellApp.BookingType.\' + booking.type}}">{{booking.type}}</td><td data-translate="{{\'getwellApp.AppointmentChange.\' + booking.appointmentChange}}">{{booking.appointmentChange}}</td><td>{{booking.customName}}</td><td><a ui-sref="end-customer-detail({id:booking.endCustomer.id})">{{booking.endCustomer.id + \' (\' + booking.endCustomer.firstname + \' \' + booking.endCustomer.lastname + \')\'}}</a></td><td><a ui-sref="treatment-detail({id:booking.treatment.id})">{{booking.treatment.type}}</a></td><td><a ui-sref="practice-detail({id:booking.treatment.practice.id})">{{booking.treatment.practice.name}}</a></td><td><a ui-sref="practice-detail({id:booking.treatment.practice.id})">{{booking.treatment.practice.id}}</a></td><td><a ui-sref="coupon-detail({id:booking.coupon.id})">{{booking.coupon.code}}</a></td><td><a ui-sref="practitioner-detail({id:booking.practitioner.id})">{{booking.practitioner.firstname + \' \' + booking.practitioner.lastname}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="booking-detail({id:booking.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="booking.edit({id:booking.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="booking.delete({id:booking.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/calendar/calendar-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.calendar.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="getwellApp.calendar.delete.question" translate-values="{id: \'{{vm.calendar.id}}\'}">Are you sure you want to delete this Calendar?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/calendar/calendar-detail.html','<div><h2><span data-translate="getwellApp.calendar.detail.title">Calendar</span> {{vm.calendar.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="getwellApp.calendar.name">Name</span></dt><dd><span>{{vm.calendar.name}}</span></dd><dt><span data-translate="getwellApp.calendar.freeSlotsBookable">Free Slots Bookable</span></dt><dd><span>{{vm.calendar.freeSlotsBookable}}</span></dd><dt><span data-translate="getwellApp.calendar.type">Type</span></dt><dd><span data-translate="{{\'getwellApp.CalendarType.\' + vm.calendar.type}}">{{vm.calendar.type}}</span></dd><dt><span data-translate="getwellApp.calendar.defaultRelatedCalendarId">Default Related Calendar Id</span></dt><dd><span>{{vm.calendar.defaultRelatedCalendarId}}</span></dd><dt><span data-translate="getwellApp.calendar.practice">Practice</span></dt><dd><a ui-sref="practice-detail({id:vm.calendar.practice.id})">{{vm.calendar.practice.id}}</a></dd><dt><span data-translate="getwellApp.calendar.practitioner">Practitioner</span></dt><dd><a ui-sref="practitioner-detail({id:vm.calendar.practitioner.id})">{{vm.calendar.practitioner.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="calendar-detail.edit({id:vm.calendar.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/calendar/calendar-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCalendarLabel" data-translate="getwellApp.calendar.home.createOrEditLabel">Create or edit a Calendar</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.calendar.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.calendar.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.calendar.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.calendar.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.calendar.freeSlotsBookable" for="field_freeSlotsBookable">Free Slots Bookable</label><input type="checkbox" class="form-control" name="freeSlotsBookable" id="field_freeSlotsBookable" ng-model="vm.calendar.freeSlotsBookable"><div ng-show="editForm.freeSlotsBookable.$invalid"><p class="help-block" ng-show="editForm.freeSlotsBookable.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.calendar.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.calendar.type" id="field_type" required><option value="PERSON" data-translate="getwellApp.CalendarType.PERSON">PERSON</option><option value="RESOURCE" data-translate="getwellApp.CalendarType.RESOURCE">RESOURCE</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.calendar.defaultRelatedCalendarId" for="field_defaultRelatedCalendarId">Default Related Calendar Id</label><input placeholder="*Number should be set, as soon as the partner-calendar exists" type="number" class="form-control" name="defaultRelatedCalendarId" id="field_defaultRelatedCalendarId" ng-model="vm.calendar.defaultRelatedCalendarId"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.calendar.practice" for="field_practice">Practice</label><input type="number" class="form-control" id="field_practice" name="practice" ng-model="vm.calendar.practice.id" required></div><div ng-show="editForm.practice.$invalid"><p class="help-block" ng-show="editForm.practice.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="getwellApp.calendar.practitioner" for="field_practitioner">Practitioner</label><em>*Leave empty for RESOURCE</em> <input placeholder="*Input for PERSON" type="number" class="form-control" id="field_practitioner" name="practitioner" ng-model="vm.calendar.practitioner.id"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/calendar/calendars.html','<div><h2 data-translate="getwellApp.calendar.home.title">Calendars</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="calendar.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="getwellApp.calendar.home.createLabel">Create new Calendar</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="getwellApp.calendar.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="freeSlotsBookable"><span data-translate="getwellApp.calendar.freeSlotsBookable">Free Slots Bookable</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="getwellApp.calendar.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="defaultRelatedCalendarId"><span data-translate="getwellApp.calendar.defaultRelatedCalendarId">Default Related Calendar Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="practice.id"><span data-translate="getwellApp.calendar.practice">Practice</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="practitioner.id"><span data-translate="getwellApp.calendar.practitioner">Practitioner</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="calendar in vm.calendars track by calendar.id"><td><a ui-sref="calendar-detail({id:calendar.id})">{{calendar.id}}</a></td><td>{{calendar.name}}</td><td>{{calendar.freeSlotsBookable}}</td><td data-translate="{{\'getwellApp.CalendarType.\' + calendar.type}}">{{calendar.type}}</td><td>{{calendar.defaultRelatedCalendarId}}</td><td><a ui-sref="practice-detail({id:calendar.practice.id})">{{calendar.practice.id}}</a></td><td><a ui-sref="practitioner-detail({id:calendar.practitioner.id})">{{calendar.practitioner.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="calendar-detail({id:calendar.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="calendar.edit({id:calendar.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="calendar.delete({id:calendar.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/coupon/coupon-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.coupon.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="getwellApp.coupon.delete.question" translate-values="{id: \'{{vm.coupon.id}}\'}">Are you sure you want to delete this Coupon?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/coupon/coupon-detail.html','<div><h2><span data-translate="getwellApp.coupon.detail.title">Coupon</span> {{vm.coupon.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="getwellApp.coupon.code">Code</span></dt><dd><span>{{vm.coupon.code}}</span></dd><dt><span data-translate="getwellApp.coupon.isPercentage">Is Percentage</span></dt><dd><span>{{vm.coupon.isPercentage}}</span></dd><dt><span data-translate="getwellApp.coupon.value">Value</span></dt><dd><span>{{vm.coupon.value}}</span></dd><dt><span data-translate="getwellApp.coupon.isActive">Is Active</span></dt><dd><span>{{vm.coupon.isActive}}</span></dd><dt><span data-translate="getwellApp.coupon.description">Description</span></dt><dd><span>{{vm.coupon.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="coupon-detail.edit({id:vm.coupon.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/coupon/coupon-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCouponLabel" data-translate="getwellApp.coupon.home.createOrEditLabel">Create or edit a Coupon</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.coupon.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.coupon.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.coupon.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.coupon.code" required ng-maxlength="50"><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.coupon.isPercentage" for="field_isPercentage">Is Percentage</label><input type="checkbox" class="form-control" name="isPercentage" id="field_isPercentage" ng-model="vm.coupon.isPercentage"><div ng-show="editForm.isPercentage.$invalid"><p class="help-block" ng-show="editForm.isPercentage.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.coupon.value" for="field_value">Value</label><input type="number" class="form-control" name="value" id="field_value" ng-model="vm.coupon.value" required><div ng-show="editForm.value.$invalid"><p class="help-block" ng-show="editForm.value.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.value.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.coupon.isActive" for="field_isActive">Is Active</label><input type="checkbox" class="form-control" name="isActive" id="field_isActive" ng-model="vm.coupon.isActive"><div ng-show="editForm.isActive.$invalid"><p class="help-block" ng-show="editForm.isActive.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.coupon.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.coupon.description" ng-maxlength="60"><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60">This field cannot be longer than 60 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/coupon/coupons.html','<div><h2 data-translate="getwellApp.coupon.home.title">Coupons</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="coupon.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="getwellApp.coupon.home.createLabel">Create new Coupon</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="getwellApp.coupon.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isPercentage"><span data-translate="getwellApp.coupon.isPercentage">Is Percentage</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="value"><span data-translate="getwellApp.coupon.value">Value</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isActive"><span data-translate="getwellApp.coupon.isActive">Is Active</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="getwellApp.coupon.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="coupon in vm.coupons track by coupon.id"><td><a ui-sref="coupon-detail({id:coupon.id})">{{coupon.id}}</a></td><td>{{coupon.code}}</td><td>{{coupon.isPercentage}}</td><td>{{coupon.value}}</td><td>{{coupon.isActive}}</td><td>{{coupon.description}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="coupon-detail({id:coupon.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="coupon.edit({id:coupon.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="coupon.delete({id:coupon.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/end-customer/end-customer-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.endCustomer.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="getwellApp.endCustomer.delete.question" translate-values="{id: \'{{vm.endCustomer.id}}\'}">Are you sure you want to delete this End Customer?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/end-customer/end-customer-detail.html','<div><h2><span data-translate="getwellApp.endCustomer.detail.title">End Customer</span> {{vm.endCustomer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="getwellApp.endCustomer.firstname">Firstname</span></dt><dd><span>{{vm.endCustomer.firstname}}</span></dd><dt><span data-translate="getwellApp.endCustomer.lastname">Lastname</span></dt><dd><span>{{vm.endCustomer.lastname}}</span></dd><dt><span data-translate="getwellApp.endCustomer.phone">Phone</span></dt><dd><span>{{vm.endCustomer.phone}}</span></dd><dt><span data-translate="getwellApp.endCustomer.salutation">Salutation</span></dt><dd><span data-translate="{{\'getwellApp.PractitionerSalutation.\' + vm.endCustomer.salutation}}">{{vm.endCustomer.salutation}}</span></dd><dt><span data-translate="getwellApp.endCustomer.addressStreet">Address Street</span></dt><dd><span>{{vm.endCustomer.addressStreet}}</span></dd><dt><span data-translate="getwellApp.endCustomer.addressStreetNumber">Address Street Number</span></dt><dd><span>{{vm.endCustomer.addressStreetNumber}}</span></dd><dt><span data-translate="getwellApp.endCustomer.addressCity">Address City</span></dt><dd><span>{{vm.endCustomer.addressCity}}</span></dd><dt><span data-translate="getwellApp.endCustomer.addressPostalCode">Address Postal Code</span></dt><dd><span>{{vm.endCustomer.addressPostalCode}}</span></dd><dt><span data-translate="getwellApp.endCustomer.email">Email</span></dt><dd><span>{{vm.endCustomer.email}}</span></dd><dt><span data-translate="getwellApp.endCustomer.dateOfBirth">Date Of Birth</span></dt><dd><span>{{vm.endCustomer.dateOfBirth | date:\'mediumDate\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="end-customer-detail.edit({id:vm.endCustomer.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/end-customer/end-customer-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEndCustomerLabel" data-translate="getwellApp.endCustomer.home.createOrEditLabel">Create or edit a End Customer</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.endCustomer.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.endCustomer.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.endCustomer.firstname" for="field_firstname">Firstname</label><input type="text" class="form-control" name="firstname" id="field_firstname" ng-model="vm.endCustomer.firstname" required ng-maxlength="50"><div ng-show="editForm.firstname.$invalid"><p class="help-block" ng-show="editForm.firstname.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.firstname.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.endCustomer.lastname" for="field_lastname">Lastname</label><input type="text" class="form-control" name="lastname" id="field_lastname" ng-model="vm.endCustomer.lastname" required ng-maxlength="50"><div ng-show="editForm.lastname.$invalid"><p class="help-block" ng-show="editForm.lastname.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.lastname.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.endCustomer.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.endCustomer.phone" required ng-maxlength="25"><div ng-show="editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="25">This field cannot be longer than 25 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.endCustomer.salutation" for="field_salutation">Salutation</label><select class="form-control" name="salutation" ng-model="vm.endCustomer.salutation" id="field_salutation" required><option value="MR" data-translate="getwellApp.PractitionerSalutation.MR">MR</option><option value="MS" data-translate="getwellApp.PractitionerSalutation.MS">MS</option></select><div ng-show="editForm.salutation.$invalid"><p class="help-block" ng-show="editForm.salutation.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.endCustomer.addressStreet" for="field_addressStreet">Address Street</label><input type="text" class="form-control" name="addressStreet" id="field_addressStreet" ng-model="vm.endCustomer.addressStreet" required ng-maxlength="50"><div ng-show="editForm.addressStreet.$invalid"><p class="help-block" ng-show="editForm.addressStreet.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.addressStreet.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.endCustomer.addressStreetNumber" for="field_addressStreetNumber">Address Street Number</label><input type="text" class="form-control" name="addressStreetNumber" id="field_addressStreetNumber" ng-model="vm.endCustomer.addressStreetNumber" required ng-maxlength="6"><div ng-show="editForm.addressStreetNumber.$invalid"><p class="help-block" ng-show="editForm.addressStreetNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.addressStreetNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="6">This field cannot be longer than 6 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.endCustomer.addressCity" for="field_addressCity">Address City</label><input type="text" class="form-control" name="addressCity" id="field_addressCity" ng-model="vm.endCustomer.addressCity" required ng-maxlength="40"><div ng-show="editForm.addressCity.$invalid"><p class="help-block" ng-show="editForm.addressCity.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.addressCity.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="40">This field cannot be longer than 40 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.endCustomer.addressPostalCode" for="field_addressPostalCode">Address Postal Code</label><input type="number" class="form-control" name="addressPostalCode" id="field_addressPostalCode" ng-model="vm.endCustomer.addressPostalCode" required max="999999"><div ng-show="editForm.addressPostalCode.$invalid"><p class="help-block" ng-show="editForm.addressPostalCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.addressPostalCode.$error.max" data-translate="entity.validation.max" translate-value-max="999999">This field cannot be more than 999999.</p><p class="help-block" ng-show="editForm.addressPostalCode.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.endCustomer.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.endCustomer.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.endCustomer.dateOfBirth" for="field_dateOfBirth">Date Of Birth</label><div class="input-group"><input id="field_dateOfBirth" type="text" class="form-control" name="dateOfBirth" uib-datepicker-popup="{{dateformat}}" ng-model="vm.endCustomer.dateOfBirth" is-open="vm.datePickerOpenStatus.dateOfBirth"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfBirth\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/end-customer/end-customers.html','<div><h2 data-translate="getwellApp.endCustomer.home.title">End Customers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="end-customer.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="getwellApp.endCustomer.home.createLabel">Create new End Customer</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firstname"><span data-translate="getwellApp.endCustomer.firstname">Firstname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastname"><span data-translate="getwellApp.endCustomer.lastname">Lastname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span data-translate="getwellApp.endCustomer.phone">Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="salutation"><span data-translate="getwellApp.endCustomer.salutation">Salutation</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressStreet"><span data-translate="getwellApp.endCustomer.addressStreet">Address Street</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressStreetNumber"><span data-translate="getwellApp.endCustomer.addressStreetNumber">Address Street Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressCity"><span data-translate="getwellApp.endCustomer.addressCity">Address City</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressPostalCode"><span data-translate="getwellApp.endCustomer.addressPostalCode">Address Postal Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="getwellApp.endCustomer.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateOfBirth"><span data-translate="getwellApp.endCustomer.dateOfBirth">Date Of Birth</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="endCustomer in vm.endCustomers track by endCustomer.id"><td><a ui-sref="end-customer-detail({id:endCustomer.id})">{{endCustomer.id}}</a></td><td>{{endCustomer.firstname}}</td><td>{{endCustomer.lastname}}</td><td>{{endCustomer.phone}}</td><td data-translate="{{\'getwellApp.PractitionerSalutation.\' + endCustomer.salutation}}">{{endCustomer.salutation}}</td><td>{{endCustomer.addressStreet}}</td><td>{{endCustomer.addressStreetNumber}}</td><td>{{endCustomer.addressCity}}</td><td>{{endCustomer.addressPostalCode}}</td><td>{{endCustomer.email}}</td><td>{{endCustomer.dateOfBirth | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="end-customer-detail({id:endCustomer.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="end-customer.edit({id:endCustomer.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="end-customer.delete({id:endCustomer.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/practice/practice-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.practice.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="getwellApp.practice.delete.question" translate-values="{id: \'{{vm.practice.id}}\'}">Are you sure you want to delete this Practice?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/practice/practice-detail.html','<div><h2><span data-translate="getwellApp.practice.detail.title">Practice</span> {{vm.practice.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="getwellApp.practice.name">Name</span></dt><dd><span>{{vm.practice.name}}</span></dd><dt><span data-translate="getwellApp.practice.phone">Phone</span></dt><dd><span>{{vm.practice.phone}}</span></dd><dt><span data-translate="getwellApp.practice.fax">Fax</span></dt><dd><span>{{vm.practice.fax}}</span></dd><dt><span data-translate="getwellApp.practice.addressStreet">Address Street</span></dt><dd><span>{{vm.practice.addressStreet}}</span></dd><dt><span data-translate="getwellApp.practice.addressStreetNumber">Address Street Number</span></dt><dd><span>{{vm.practice.addressStreetNumber}}</span></dd><dt><span data-translate="getwellApp.practice.addressCity">Address City</span></dt><dd><span>{{vm.practice.addressCity}}</span></dd><dt><span data-translate="getwellApp.practice.addressStreetMore">Address Street More</span></dt><dd><span>{{vm.practice.addressStreetMore}}</span></dd><dt><span data-translate="getwellApp.practice.addressPostalCode">Address Postal Code</span></dt><dd><span>{{vm.practice.addressPostalCode}}</span></dd><dt><span data-translate="getwellApp.practice.email">Email</span></dt><dd><span>{{vm.practice.email}}</span></dd><dt><span data-translate="getwellApp.practice.professionalCategory">Professional Category</span></dt><dd><span data-translate="{{\'getwellApp.ProfessionalCategory.\' + vm.practice.professionalCategory}}">{{vm.practice.professionalCategory}}</span></dd><dt><span data-translate="getwellApp.practice.networkedPracticeName">Networked Practice Name</span></dt><dd><span>{{vm.practice.networkedPracticeName}}</span></dd><dt><span data-translate="getwellApp.practice.networkedPractice">Networked Practice</span></dt><dd><span>{{vm.practice.networkedPractice}}</span></dd><dt><span data-translate="getwellApp.practice.picture">Picture</span></dt><dd><div ng-if="vm.practice.picture"><a ng-click="vm.openFile(vm.practice.pictureContentType, vm.practice.picture)"><img data-ng-src="{{\'data:\' + vm.practice.pictureContentType + \';base64,\' + vm.practice.picture}}" style="max-width: 100%" alt="practice image"> </a>{{vm.practice.pictureContentType}}, {{vm.byteSize(vm.practice.picture)}}</div></dd><dt><span data-translate="getwellApp.practice.notes">Notes</span></dt><dd><span>{{vm.practice.notes}}</span></dd><dt><span data-translate="getwellApp.practice.taxpunktwert">Taxpunktwert</span></dt><dd><span>{{vm.practice.taxpunktwert}}</span></dd><dt><span data-translate="getwellApp.practice.bookingTerms">Booking Terms</span></dt><dd><span style="white-space: pre-wrap">{{vm.practice.bookingTerms}}</span></dd><dt><span data-translate="getwellApp.practice.location">Location</span></dt><dd><span data-translate="{{\'getwellApp.PracticeLocation.\' + vm.practice.location}}">{{vm.practice.location}}</span></dd><dt><span data-translate="getwellApp.practice.coordinates">Coordinates</span></dt><dd><span>{{vm.practice.coordinates}}</span></dd><dt><span data-translate="getwellApp.practice.showBusinessCard">Show Business Card</span></dt><dd><span>{{vm.practice.showBusinessCard}}</span></dd><dt><span data-translate="getwellApp.practice.locationDescription">Location Description</span></dt><dd><span>{{vm.practice.locationDescription}}</span></dd><dt><span data-translate="getwellApp.practice.profilePath">Profile Path</span></dt><dd><span>{{vm.practice.profilePath}}</span></dd><dt><span data-translate="getwellApp.practice.externalCalendarId">External Calendar Id</span></dt><dd><span>{{vm.practice.externalCalendarId}}</span></dd><dt><span data-translate="getwellApp.practice.externalCalendarCredential">External Calendar Credential</span></dt><dd><span>{{vm.practice.externalCalendarCredential}}</span></dd><dt><span data-translate="getwellApp.practice.externalCalendarData">External Calendar Data</span></dt><dd><span>{{vm.practice.externalCalendarData}}</span></dd><dt><span data-translate="getwellApp.practice.languages">Languages</span></dt><dd><span>{{vm.practice.languages}}</span></dd><dt><span data-translate="getwellApp.practice.specializations">Specializations</span></dt><dd><span>{{vm.practice.specializations}}</span></dd><dt><span data-translate="getwellApp.practice.teaser">Teaser</span></dt><dd><span>{{vm.practice.teaser}}</span></dd><dt><span data-translate="getwellApp.practice.teaserData">Teaser Data</span></dt><dd><span>{{vm.practice.teaserData}}</span></dd><dt><span data-translate="getwellApp.practice.standaloneStyle">Standalone Style</span></dt><dd><span style="white-space: pre-wrap">{{vm.practice.standaloneStyle}}</span></dd><dt><span data-translate="getwellApp.practice.calendarType">Calendar Type</span></dt><dd><span data-translate="{{\'getwellApp.PracticeCalendarType.\' + vm.practice.calendarType}}">{{vm.practice.calendarType}}</span></dd><button type="button" class="btn btn-default" ng-click="vm.showExternalCalendarInfo()" ng-show="vm.isExternalCalendar()"><span class="glyphicon glyphicon-info-sign"></span>&nbsp;<span data-translate="getwellApp.practice.showExternalCalendarInfo">Show External Calendar Info</span></button><dt><span data-translate="getwellApp.practice.practitioner">Practitioner</span></dt><dd><span ng-repeat="practitioner in vm.practice.practitioners"><a ui-sref="practitioner-detail({id: practitioner.id})">{{practitioner.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="getwellApp.practice.practiceProfile">Practice Profile</span></dt><dd><a ui-sref="practice-profile-detail({id:vm.practice.practiceProfile.id})">{{vm.practice.practiceProfile.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="practice-detail.edit({id:vm.practice.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/practice/practice-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPracticeLabel" data-translate="getwellApp.practice.home.createOrEditLabel">Create or edit a Practice</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.practice.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.practice.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.practice.name" required ng-maxlength="100"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.practice.phone" required ng-maxlength="15"><div ng-show="editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.fax" for="field_fax">Fax</label><input type="text" class="form-control" name="fax" id="field_fax" ng-model="vm.practice.fax" ng-maxlength="15"><div ng-show="editForm.fax.$invalid"><p class="help-block" ng-show="editForm.fax.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.addressStreet" for="field_addressStreet">Address Street</label><input type="text" class="form-control" name="addressStreet" id="field_addressStreet" ng-model="vm.practice.addressStreet" required ng-maxlength="50"><div ng-show="editForm.addressStreet.$invalid"><p class="help-block" ng-show="editForm.addressStreet.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.addressStreet.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.addressStreetNumber" for="field_addressStreetNumber">Address Street Number</label><input type="text" class="form-control" name="addressStreetNumber" id="field_addressStreetNumber" ng-model="vm.practice.addressStreetNumber" ng-maxlength="6"><div ng-show="editForm.addressStreetNumber.$invalid"><p class="help-block" ng-show="editForm.addressStreetNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="6">This field cannot be longer than 6 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.addressCity" for="field_addressCity">Address City</label><input type="text" class="form-control" name="addressCity" id="field_addressCity" ng-model="vm.practice.addressCity" ng-maxlength="50"><div ng-show="editForm.addressCity.$invalid"><p class="help-block" ng-show="editForm.addressCity.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.addressStreetMore" for="field_addressStreetMore">Address Street More</label><input type="text" class="form-control" name="addressStreetMore" id="field_addressStreetMore" ng-model="vm.practice.addressStreetMore" ng-maxlength="50"><div ng-show="editForm.addressStreetMore.$invalid"><p class="help-block" ng-show="editForm.addressStreetMore.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.addressPostalCode" for="field_addressPostalCode">Address Postal Code</label><input type="number" class="form-control" name="addressPostalCode" id="field_addressPostalCode" ng-model="vm.practice.addressPostalCode" required max="999999"><div ng-show="editForm.addressPostalCode.$invalid"><p class="help-block" ng-show="editForm.addressPostalCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.addressPostalCode.$error.max" data-translate="entity.validation.max" translate-value-max="999999">This field cannot be more than 999999.</p><p class="help-block" ng-show="editForm.addressPostalCode.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_email">Emails (separated by semicolon ; )</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.practice.email" required ng-maxlength="100" placeholder="info@zumedo.ch; customer@zumedo.ch"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.professionalCategory" for="field_professionalCategory">Professional Category</label><select class="form-control" name="professionalCategory" ng-model="vm.practice.professionalCategory" id="field_professionalCategory" required><option value="DENTAL_PRACTITIONER" data-translate="getwellApp.ProfessionalCategory.DENTAL_PRACTITIONER">DENTAL_PRACTITIONER</option><option value="PHYSICIAN" data-translate="getwellApp.ProfessionalCategory.PHYSICIAN">PHYSICIAN</option></select><div ng-show="editForm.professionalCategory.$invalid"><p class="help-block" ng-show="editForm.professionalCategory.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.networkedPracticeName" for="field_networkedPracticeName">Networked Practice Name</label><input type="text" class="form-control" name="networkedPracticeName" id="field_networkedPracticeName" ng-model="vm.practice.networkedPracticeName" ng-maxlength="50"><div ng-show="editForm.networkedPracticeName.$invalid"><p class="help-block" ng-show="editForm.networkedPracticeName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.networkedPractice" for="field_networkedPractice">Networked Practice</label><input type="checkbox" class="form-control" name="networkedPractice" id="field_networkedPractice" ng-model="vm.practice.networkedPractice"></div><div class="form-group" ngf-drop ngf-change="vm.setPicture($file, vm.practice)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="getwellApp.practice.picture" for="field_picture">Picture</label><div><img data-ng-src="{{\'data:\' + vm.practice.pictureContentType + \';base64,\' + vm.practice.picture}}" style="max-height: 100px" ng-if="vm.practice.picture" alt="practice image"><div ng-if="vm.practice.picture" class="help-block clearfix"><span class="pull-left">{{vm.practice.pictureContentType}}, {{vm.byteSize(vm.practice.picture)}}</span> <button type="button" ng-click="vm.practice.picture=null;vm.practice.pictureContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setPicture($file, vm.practice)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="picture" id="field_picture" ng-model="vm.practice.picture"> <input type="hidden" class="form-control" name="pictureContentType" id="field_pictureContentType" ng-model="vm.practice.pictureContentType"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.notes" for="field_notes">Notes</label><input type="text" class="form-control" name="notes" id="field_notes" ng-model="vm.practice.notes" ng-maxlength="2000"><div ng-show="editForm.notes.$invalid"><p class="help-block" ng-show="editForm.notes.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2000">This field cannot be longer than 2000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.taxpunktwert" for="field_taxpunktwert">Taxpunktwert</label><input type="text" class="form-control" name="taxpunktwert" id="field_taxpunktwert" ng-model="vm.practice.taxpunktwert" ng-maxlength="20"><div ng-show="editForm.taxpunktwert.$invalid"><p class="help-block" ng-show="editForm.taxpunktwert.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.bookingTerms" for="field_bookingTerms">Booking Terms</label><textarea class="form-control" name="bookingTerms" id="field_bookingTerms" ng-model="vm.practice.bookingTerms" required ng-maxlength="2000"></textarea><div ng-show="editForm.bookingTerms.$invalid"><p class="help-block" ng-show="editForm.bookingTerms.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.bookingTerms.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2000">This field cannot be longer than 2000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.location" for="field_location">Location</label><select class="form-control" name="location" ng-model="vm.practice.location" id="field_location" required><option value="ZURICH" data-translate="getwellApp.PracticeLocation.ZURICH">ZURICH</option><option value="BERN" data-translate="getwellApp.PracticeLocation.BERN">BERN</option><option value="BASEL" data-translate="getwellApp.PracticeLocation.BASEL">BASEL</option><option value="LUZERN" data-translate="getwellApp.PracticeLocation.LUZERN">LUZERN</option><option value="WINTERTHUR" data-translate="getwellApp.PracticeLocation.WINTERTHUR">WINTERTHUR</option><option value="ZUG" data-translate="getwellApp.PracticeLocation.ZUG">ZUG</option><option value="CHUR" data-translate="getwellApp.PracticeLocation.CHUR">CHUR</option><option value="ST_GALLEN" data-translate="getwellApp.PracticeLocation.ST_GALLEN">ST_GALLEN</option><option value="SCHAFFHAUSEN" data-translate="getwellApp.PracticeLocation.SCHAFFHAUSEN">SCHAFFHAUSEN</option><option value="LAUSANNE" data-translate="getwellApp.PracticeLocation.LAUSANNE">LAUSANNE</option><option value="THUN" data-translate="getwellApp.PracticeLocation.THUN">THUN</option><option value="NIDWALDEN" data-translate="getwellApp.PracticeLocation.NIDWALDEN">NIDWALDEN</option><option value="AARGAU" data-translate="getwellApp.PracticeLocation.AARGAU">AARGAU</option><option value="BIEL" data-translate="getwellApp.PracticeLocation.BIEL">BIEL</option><option value="FREIBURG" data-translate="getwellApp.PracticeLocation.FREIBURG">FREIBURG</option><option value="NEUENBURG" data-translate="getwellApp.PracticeLocation.NEUENBURG">NEUENBURG</option><option value="SION" data-translate="getwellApp.PracticeLocation.SION">SION</option><option value="FRAUENFELD" data-translate="getwellApp.PracticeLocation.FRAUENFELD">FRAUENFELD</option><option value="OLTEN" data-translate="getwellApp.PracticeLocation.OLTEN">OLTEN</option><option value="SOLOTHURN" data-translate="getwellApp.PracticeLocation.SOLOTHURN">SOLOTHURN</option><option value="BURGDORF" data-translate="getwellApp.PracticeLocation.BURGDORF">BURGDORF</option><option value="LANGENTHAL" data-translate="getwellApp.PracticeLocation.LANGENTHAL">LANGENTHAL</option><option value="APPENZELLERLAND" data-translate="getwellApp.PracticeLocation.APPENZELLERLAND">APPENZELLERLAND</option></select><div ng-show="editForm.location.$invalid"><p class="help-block" ng-show="editForm.location.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.coordinates" for="field_coordinates">Coordinates</label><input type="text" class="form-control" name="coordinates" id="field_coordinates" ng-model="vm.practice.coordinates" required ng-pattern="/^\\d+\\.\\d+,\\d+\\.\\d+$/"><div ng-show="editForm.coordinates.$invalid"><p class="help-block" ng-show="editForm.coordinates.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.coordinates.$error.pattern" data-translate="entity.validation.pattern" translate-value-pattern="^\\d+\\.\\d+,\\d+\\.\\d+$">This field should follow pattern "^\\d+\\.\\d+,\\d+\\.\\d+$".</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.showBusinessCard" for="field_showBusinessCard">Show Business Card</label><input type="checkbox" class="form-control" name="showBusinessCard" id="field_showBusinessCard" ng-model="vm.practice.showBusinessCard"><div ng-show="editForm.showBusinessCard.$invalid"><p class="help-block" ng-show="editForm.showBusinessCard.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.locationDescription" for="field_locationDescription">Location Description</label><input type="text" class="form-control" name="locationDescription" id="field_locationDescription" ng-model="vm.practice.locationDescription" required><div ng-show="editForm.locationDescription.$invalid"><p class="help-block" ng-show="editForm.locationDescription.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.profilePath" for="field_profilePath">Profile Path</label><input type="text" class="form-control" name="profilePath" id="field_profilePath" ng-model="vm.practice.profilePath" required><div ng-show="editForm.profilePath.$invalid"><p class="help-block" ng-show="editForm.profilePath.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.externalCalendarId" for="field_externalCalendarId">External Calendar Id</label><input type="text" class="form-control" name="externalCalendarId" id="field_externalCalendarId" ng-model="vm.practice.externalCalendarId" ng-maxlength="50"><div ng-show="editForm.externalCalendarId.$invalid"><p class="help-block" ng-show="editForm.externalCalendarId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.externalCalendarCredential" for="field_externalCalendarCredential">External Calendar Credential</label><input type="text" class="form-control" name="externalCalendarCredential" id="field_externalCalendarCredential" ng-model="vm.practice.externalCalendarCredential" ng-maxlength="50"><div ng-show="editForm.externalCalendarCredential.$invalid"><p class="help-block" ng-show="editForm.externalCalendarCredential.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.externalCalendarData" for="field_externalCalendarData">External Calendar Data</label><input type="text" class="form-control" name="externalCalendarData" id="field_externalCalendarData" ng-model="vm.practice.externalCalendarData" ng-maxlength="50"><div ng-show="editForm.externalCalendarData.$invalid"><p class="help-block" ng-show="editForm.externalCalendarData.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label for="field_practitioner">Practitioners (e.g. 47, 48, 9, 10, 14, 33)</label><input type="text" class="form-control" name="field_practitioner" id="field_practitioner" ng-model="vm.practitionersString"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.languages" for="field_languages">Languages</label><input type="text" class="form-control" name="languages" id="field_languages" ng-model="vm.practice.languages" ng-maxlength="200"><div ng-show="editForm.languages.$invalid"><p class="help-block" ng-show="editForm.languages.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.specializations" for="field_specializations">Specializations</label><input type="text" class="form-control" name="specializations" id="field_specializations" ng-model="vm.practice.specializations" ng-maxlength="1000"><div ng-show="editForm.specializations.$invalid"><p class="help-block" ng-show="editForm.specializations.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.teaser" for="field_teaser">Teaser</label><input type="checkbox" class="form-control" name="teaser" id="field_teaser" ng-model="vm.practice.teaser"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.teaserData" for="field_teaserData">Teaser Data</label><input type="text" class="form-control" name="teaserData" id="field_teaserData" ng-model="vm.practice.teaserData" ng-maxlength="2000" ng-pattern="/^(MR|MS);[-\\w.\xE4\xFC\xF6\xC4\xD6\xDC\xE8\xE9\xE0 ]*;[-\\w.\xE4\xFC\xF6\xC4\xD6\xDC\xE8\xE9\xE0 ]+(;[-.:/\\w\xE4\xFC\xF6\xC4\xD6\xDC\xE8\xE9\xE0 ]*)*$/" placeholder="MR/MS;Title and Full Name;Professional Category;Picture-Url;..."><div ng-show="editForm.teaserData.$invalid"><p class="help-block" ng-show="editForm.teaserData.$error.pattern" data-translate="entity.validation.pattern" translate-value-pattern="/^(MR|MS);[-\\w.\xE4\xFC\xF6\xC4\xD6\xDC\xE8\xE9\xE0 ]*;[-\\w.\xE4\xFC\xF6\xC4\xD6\xDC\xE8\xE9\xE0 ]+(;[-.:/\\w\xE4\xFC\xF6\xC4\xD6\xDC\xE8\xE9\xE0 ]*)*$/">This field should follow pattern "/^(MR|MS);[-\\w.\xE4\xFC\xF6\xC4\xD6\xDC\xE8\xE9\xE0 ]*;[-\\w.\xE4\xFC\xF6\xC4\xD6\xDC\xE8\xE9\xE0 ]+(;[-.:/\\w\xE4\xFC\xF6\xC4\xD6\xDC\xE8\xE9\xE0 ]*)*$/". (Example: "MR;Dr. Haruki Murakami;Writer")</p><p class="help-block" ng-show="editForm.teaserData.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2000">This field cannot be longer than 2000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.standaloneStyle" for="field_standaloneStyle">Standalone Style</label><textarea class="form-control" name="standaloneStyle" id="field_standaloneStyle" ng-model="vm.practice.standaloneStyle" ng-maxlength="2000"></textarea><div ng-show="editForm.standaloneStyle.$invalid"><p class="help-block" ng-show="editForm.standaloneStyle.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2000">This field cannot be longer than 2000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practice.calendarType" for="field_calendarType">Calendar Type</label><select class="form-control" name="calendarType" ng-model="vm.practice.calendarType" id="field_calendarType" required><option value="ZUMEDO" data-translate="getwellApp.PracticeCalendarType.ZUMEDO">ZUMEDO</option><option value="ZAWIN" data-translate="getwellApp.PracticeCalendarType.ZAWIN">ZAWIN</option><option value="ERGODENT" data-translate="getwellApp.PracticeCalendarType.ERGODENT">ERGODENT</option><option value="DENTEO" data-translate="getwellApp.PracticeCalendarType.DENTEO">DENTEO</option></select><div ng-show="editForm.calendarType.$invalid"><p class="help-block" ng-show="editForm.calendarType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="getwellApp.practice.practiceProfile" for="field_practiceProfile">Practice Profile</label><input type="number" class="form-control" name="practiceProfile" id="field_practiceProfile" ng-model="vm.practice.practiceProfile.id"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/practice/practices.html','<div><h2 data-translate="getwellApp.practice.home.title">Practices</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="practice.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="getwellApp.practice.home.createLabel">Create new Practice</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="getwellApp.practice.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span data-translate="getwellApp.practice.phone">Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fax"><span data-translate="getwellApp.practice.fax">Fax</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressStreet"><span data-translate="getwellApp.practice.addressStreet">Address Street</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressStreetNumber"><span data-translate="getwellApp.practice.addressStreetNumber">Address Street Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressCity"><span data-translate="getwellApp.practice.addressCity">Address City</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressStreetMore"><span data-translate="getwellApp.practice.addressStreetMore">Address Street More</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressPostalCode"><span data-translate="getwellApp.practice.addressPostalCode">Address Postal Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="getwellApp.practice.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="professionalCategory"><span data-translate="getwellApp.practice.professionalCategory">Professional Category</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="networkedPracticeName"><span data-translate="getwellApp.practice.networkedPracticeName">Networked Practice Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="networkedPractice"><span data-translate="getwellApp.practice.networkedPractice">Networked Practice</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="picture"><span data-translate="getwellApp.practice.picture">Picture</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="notes"><span data-translate="getwellApp.practice.notes">Notes</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="taxpunktwert"><span data-translate="getwellApp.practice.taxpunktwert">Taxpunktwert</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bookingTerms"><span data-translate="getwellApp.practice.bookingTerms">Booking Terms</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="location"><span data-translate="getwellApp.practice.location">Location</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="coordinates"><span data-translate="getwellApp.practice.coordinates">Coordinates</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="showBusinessCard"><span data-translate="getwellApp.practice.showBusinessCard">Show Business Card</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="locationDescription"><span data-translate="getwellApp.practice.locationDescription">Location Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profilePath"><span data-translate="getwellApp.practice.profilePath">Profile Path</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="externalCalendarId"><span data-translate="getwellApp.practice.externalCalendarId">External Calendar Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="externalCalendarCredential"><span data-translate="getwellApp.practice.externalCalendarCredential">External Calendar Credential</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="externalCalendarData"><span data-translate="getwellApp.practice.externalCalendarData">External Calendar Data</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="languages"><span data-translate="getwellApp.practice.languages">Languages</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="specializations"><span data-translate="getwellApp.practice.specializations">Specializations</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="teaser"><span data-translate="getwellApp.practice.teaser">Teaser</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="teaserData"><span data-translate="getwellApp.practice.teaserData">Teaser Data</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="calendarType"><span data-translate="getwellApp.practice.calendarType">Calendar Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="practiceProfile.id"><span data-translate="getwellApp.practice.practiceProfile">Practice Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="practice in vm.practices track by practice.id"><td><a ui-sref="practice-detail({id:practice.id})">{{practice.id}}</a></td><td>{{practice.name}}</td><td>{{practice.phone}}</td><td>{{practice.fax}}</td><td>{{practice.addressStreet}}</td><td>{{practice.addressStreetNumber}}</td><td>{{practice.addressCity}}</td><td>{{practice.addressStreetMore}}</td><td>{{practice.addressPostalCode}}</td><td>{{practice.email}}</td><td data-translate="{{\'getwellApp.ProfessionalCategory.\' + practice.professionalCategory}}">{{practice.professionalCategory}}</td><td>{{practice.networkedPracticeName}}</td><td>{{practice.networkedPractice}}</td><td><a ng-if="practice.picture" ng-click="vm.openFile(practice.pictureContentType, practice.picture)"><img data-ng-src="{{\'data:\' + practice.pictureContentType + \';base64,\' + practice.picture}}" style="max-height: 30px" alt="practice image"> </a><span ng-if="practice.picture">{{practice.pictureContentType}}, {{vm.byteSize(practice.picture)}}</span></td><td>{{practice.notes}}</td><td>{{practice.taxpunktwert}}</td><td>{{practice.bookingTerms}}</td><td data-translate="{{\'getwellApp.PracticeLocation.\' + practice.location}}">{{practice.location}}</td><td>{{practice.coordinates}}</td><td>{{practice.showBusinessCard}}</td><td>{{practice.locationDescription}}</td><td>{{practice.profilePath}}</td><td>{{practice.externalCalendarId}}</td><td>{{practice.externalCalendarCredential}}</td><td>{{practice.externalCalendarData}}</td><td>{{practice.languages}}</td><td>{{practice.specializations}}</td><td>{{practice.teaser}}</td><td>{{practice.teaserData}}</td><td data-translate="{{\'getwellApp.PracticeCalendarType.\' + practice.calendarType}}">{{practice.calendarType}}</td><td><a ui-sref="practice-profile-detail({id:practice.practiceProfile.id})">{{practice.practiceProfile.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="practice-detail({id:practice.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="practice.edit({id:practice.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="practice.delete({id:practice.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/practice-profile/practice-profile-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.practiceProfile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="getwellApp.practiceProfile.delete.question" translate-values="{id: \'{{vm.practiceProfile.id}}\'}">Are you sure you want to delete this Practice Profile?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/practice-profile/practice-profile-detail.html','<div><h2><span data-translate="getwellApp.practiceProfile.detail.title">Practice Profile</span> {{vm.practiceProfile.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="getwellApp.practiceProfile.location_directions">Location Directions</span></dt><dd><span>{{vm.practiceProfile.location_directions}}</span></dd><dt><span data-translate="getwellApp.practiceProfile.images">Images</span></dt><dd><span>{{vm.practiceProfile.images}}</span></dd><dt><span data-translate="getwellApp.practiceProfile.description">Description</span></dt><dd><span>{{vm.practiceProfile.description}}</span></dd><dt><span data-translate="getwellApp.practiceProfile.welcome_message">Welcome Message</span></dt><dd><span>{{vm.practiceProfile.welcome_message}}</span></dd><dt><span data-translate="getwellApp.practiceProfile.slogan">Slogan</span></dt><dd><span>{{vm.practiceProfile.slogan}}</span></dd><dt><span data-translate="getwellApp.practiceProfile.taxpunktwert">Taxpunktwert</span></dt><dd><span>{{vm.practiceProfile.taxpunktwert}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="practice-profile-detail.edit({id:vm.practiceProfile.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/practice-profile/practice-profile-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPracticeProfileLabel" data-translate="getwellApp.practiceProfile.home.createOrEditLabel">Create or edit a Practice Profile</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.practiceProfile.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.practiceProfile.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practiceProfile.welcome_message" for="field_welcome_message">Welcome Message</label><input type="text" class="form-control" name="welcome_message" id="field_welcome_message" ng-model="vm.practiceProfile.welcome_message" ng-maxlength="250"><div ng-show="editForm.welcome_message.$invalid"><p class="help-block" ng-show="editForm.welcome_message.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practiceProfile.slogan" for="field_slogan">Slogan</label><input type="text" class="form-control" name="slogan" id="field_slogan" ng-model="vm.practiceProfile.slogan" ng-maxlength="250"><div ng-show="editForm.slogan.$invalid"><p class="help-block" ng-show="editForm.slogan.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practiceProfile.images" for="field_images">Images</label><input type="text" class="form-control" name="images" id="field_images" ng-model="vm.practiceProfile.images" required ng-maxlength="200"><div ng-show="editForm.images.$invalid"><p class="help-block" ng-show="editForm.images.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.images.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practiceProfile.description" for="field_description">Description</label><textarea type="text" class="form-control" name="description" id="field_description" ng-model="vm.practiceProfile.description" required ng-maxlength="2000"></textarea><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.description.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2000">This field cannot be longer than 2000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practiceProfile.location_directions" for="field_location_directions">Location Directions</label><textarea type="text" class="form-control" name="location_directions" id="field_location_directions" ng-model="vm.practiceProfile.location_directions" required ng-maxlength="1000"></textarea><div ng-show="editForm.location_directions.$invalid"><p class="help-block" ng-show="editForm.location_directions.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.location_directions.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practiceProfile.taxpunktwert" for="field_taxpunktwert">Taxpunktwert</label><input type="text" class="form-control" name="taxpunktwert" id="field_taxpunktwert" ng-model="vm.practiceProfile.taxpunktwert" ng-maxlength="100"><div ng-show="editForm.taxpunktwert.$invalid"><p class="help-block" ng-show="editForm.taxpunktwert.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/practice-profile/practice-profiles.html','<div><h2 data-translate="getwellApp.practiceProfile.home.title">Practice Profiles</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="practice-profile.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="getwellApp.practiceProfile.home.createLabel">Create new Practice Profile</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="practiceName"><span data-translate="Practice Name">Practice Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="welcome_message"><span data-translate="getwellApp.practiceProfile.welcome_message">Welcome Message</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="slogan"><span data-translate="getwellApp.practiceProfile.slogan">Slogan</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="images"><span data-translate="getwellApp.practiceProfile.images">Images</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="getwellApp.practiceProfile.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="location_directions"><span data-translate="getwellApp.practiceProfile.location_directions">Location Directions</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="taxpunktwert"><span data-translate="getwellApp.practiceProfile.taxpunktwert">Taxpunktwert</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="practiceProfile in vm.practiceProfiles track by practiceProfile.id"><td><a ui-sref="practice-profile-detail({id:practiceProfile.id})">{{practiceProfile.id}}</a></td><td>{{practiceProfile.practiceName}}</td><td>{{practiceProfile.welcome_message}}</td><td>{{practiceProfile.slogan}}</td><td>{{practiceProfile.images}}</td><td>{{practiceProfile.description}}</td><td>{{practiceProfile.location_directions}}</td><td>{{practiceProfile.taxpunktwert}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="practice-profile-detail({id:practiceProfile.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="practice-profile.edit({id:practiceProfile.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="practice-profile.delete({id:practiceProfile.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/practitioner/practitioner-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.practitioner.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="getwellApp.practitioner.delete.question" translate-values="{id: \'{{vm.practitioner.id}}\'}">Are you sure you want to delete this Practitioner?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/practitioner/practitioner-detail.html','<div><h2><span data-translate="getwellApp.practitioner.detail.title">Practitioner</span> {{vm.practitioner.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="getwellApp.practitioner.title">Title</span></dt><dd><span>{{vm.practitioner.title}}</span></dd><dt><span data-translate="getwellApp.practitioner.salutation">Salutation</span></dt><dd><span data-translate="{{\'getwellApp.PractitionerSalutation.\' + vm.practitioner.salutation}}">{{vm.practitioner.salutation}}</span></dd><dt><span data-translate="getwellApp.practitioner.firstname">Firstname</span></dt><dd><span>{{vm.practitioner.firstname}}</span></dd><dt><span data-translate="getwellApp.practitioner.lastname">Lastname</span></dt><dd><span>{{vm.practitioner.lastname}}</span></dd><dt><span data-translate="getwellApp.practitioner.phone">Phone</span></dt><dd><span>{{vm.practitioner.phone}}</span></dd><dt><span data-translate="getwellApp.practitioner.addressStreet">Address Street</span></dt><dd><span>{{vm.practitioner.addressStreet}}</span></dd><dt><span data-translate="getwellApp.practitioner.addressStreetNumber">Address Street Number</span></dt><dd><span>{{vm.practitioner.addressStreetNumber}}</span></dd><dt><span data-translate="getwellApp.practitioner.addressCity">Address City</span></dt><dd><span>{{vm.practitioner.addressCity}}</span></dd><dt><span data-translate="getwellApp.practitioner.addressPostalCode">Address Postal Code</span></dt><dd><span>{{vm.practitioner.addressPostalCode}}</span></dd><dt><span data-translate="getwellApp.practitioner.profession">Profession</span></dt><dd><span data-translate="{{\'getwellApp.Profession.\' + vm.practitioner.profession}}">{{vm.practitioner.profession}}</span></dd><dt><span data-translate="getwellApp.practitioner.professionalCategory">Professional Category</span></dt><dd><span data-translate="{{\'getwellApp.ProfessionalCategory.\' + vm.practitioner.professionalCategory}}">{{vm.practitioner.professionalCategory}}</span></dd><dt><span data-translate="getwellApp.practitioner.email">Email</span></dt><dd><span>{{vm.practitioner.email}}</span></dd><dt><span data-translate="getwellApp.practitioner.pictureUrl">Picture Url</span></dt><dd><span>{{vm.practitioner.pictureUrl}}</span></dd><dt><span data-translate="getwellApp.practitioner.taxpunktwert">Taxpunktwert</span></dt><dd><span>{{vm.practitioner.taxpunktwert}}</span></dd><dt><span data-translate="getwellApp.practitioner.externalCalendarId">External Calendar Id</span></dt><dd><span>{{vm.practitioner.externalCalendarId}}</span></dd><dt><span data-translate="getwellApp.practitioner.externalCalendarData">External Calendar Data</span></dt><dd><span>{{vm.practitioner.externalCalendarData}}</span></dd><dt><span data-translate="getwellApp.practitioner.bookingPictureUrl">Booking Picture Url</span></dt><dd><span>{{vm.practitioner.bookingPictureUrl}}</span></dd><dt><span data-translate="getwellApp.practitioner.cvUrl">Cv Url</span></dt><dd><span>{{vm.practitioner.cvUrl}}</span></dd><dt><span data-translate="getwellApp.practitioner.customProfession">Custom Profession</span></dt><dd><span>{{vm.practitioner.customProfession}}</span></dd><dt><span data-translate="getwellApp.practitioner.sortingOrder">Sorting Order</span></dt><dd><span>{{vm.practitioner.sortingOrder}}</span></dd><dt><span data-translate="getwellApp.practitioner.hideOnProfile">Hide On Profile</span></dt><dd><span>{{vm.practitioner.hideOnProfile}}</span></dd><!--                 <dt><span data-translate="getwellApp.practitioner.titleText">Title Text</span></dt> --><!--         <dd> --><!--             <span>{{vm.practitioner.titleText}}</span> --><!--         </dd> --><dt><span data-translate="getwellApp.practitioner.treatment">Treatment</span></dt><dd><span ng-repeat="treatment in vm.practitioner.treatments"><a ui-sref="treatment-detail({id: treatment.id})">{{(\'getwellApp.TreatmentType.\' + treatment.type | translate) + \' (\' + treatment.id + ((treatment.customName != null && treatment.customName != \'\') ? \', \' + treatment.customName : \'\') + \')\'}} </a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="practitioner-detail.edit({id:vm.practitioner.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/practitioner/practitioner-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPractitionerLabel" data-translate="getwellApp.practitioner.home.createOrEditLabel">Create or edit a Practitioner</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.practitioner.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.practitioner.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.practitioner.title" ng-maxlength="50"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><!--         <div class="form-group"> --><!--             <label class="control-label" data-translate="getwellApp.practitioner.titleText" for="field_titleText">Title Text</label> --><!--             <input type="text" class="form-control" name="titleText" id="field_titleText" --><!--                     ng-model="vm.practitioner.titleText" --><!--                     ng-maxlength="100"/> --><!--             <div ng-show="editForm.titleText.$invalid"> --><!--                 <p class="help-block" --><!--                     ng-show="editForm.titleText.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100"> --><!--                     This field cannot be longer than 100 characters. --><!--                 </p> --><!--             </div> --><!--         </div> --><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.salutation" for="field_salutation">Salutation</label><select class="form-control" name="salutation" ng-model="vm.practitioner.salutation" id="field_salutation" required><option value="MR" data-translate="getwellApp.PractitionerSalutation.MR">MR</option><option value="MS" data-translate="getwellApp.PractitionerSalutation.MS">MS</option></select><div ng-show="editForm.salutation.$invalid"><p class="help-block" ng-show="editForm.salutation.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.firstname" for="field_firstname">Firstname</label><input type="text" class="form-control" name="firstname" id="field_firstname" ng-model="vm.practitioner.firstname" required ng-maxlength="50"><div ng-show="editForm.firstname.$invalid"><p class="help-block" ng-show="editForm.firstname.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.firstname.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.lastname" for="field_lastname">Lastname</label><input type="text" class="form-control" name="lastname" id="field_lastname" ng-model="vm.practitioner.lastname" required ng-maxlength="50"><div ng-show="editForm.lastname.$invalid"><p class="help-block" ng-show="editForm.lastname.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.lastname.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.practitioner.phone" required ng-maxlength="15"><div ng-show="editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.addressStreet" for="field_addressStreet">Address Street</label><input type="text" class="form-control" name="addressStreet" id="field_addressStreet" ng-model="vm.practitioner.addressStreet" ng-maxlength="50"><div ng-show="editForm.addressStreet.$invalid"><p class="help-block" ng-show="editForm.addressStreet.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.addressStreetNumber" for="field_addressStreetNumber">Address Street Number</label><input type="text" class="form-control" name="addressStreetNumber" id="field_addressStreetNumber" ng-model="vm.practitioner.addressStreetNumber" ng-maxlength="6"><div ng-show="editForm.addressStreetNumber.$invalid"><p class="help-block" ng-show="editForm.addressStreetNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="6">This field cannot be longer than 6 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.addressCity" for="field_addressCity">Address City</label><input type="text" class="form-control" name="addressCity" id="field_addressCity" ng-model="vm.practitioner.addressCity" ng-maxlength="40"><div ng-show="editForm.addressCity.$invalid"><p class="help-block" ng-show="editForm.addressCity.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="40">This field cannot be longer than 40 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.addressPostalCode" for="field_addressPostalCode">Address Postal Code</label><input type="number" class="form-control" name="addressPostalCode" id="field_addressPostalCode" ng-model="vm.practitioner.addressPostalCode"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.profession" for="field_profession">Profession</label><select class="form-control" name="profession" ng-model="vm.practitioner.profession" id="field_profession" required><option value="DENTIST" data-translate="getwellApp.Profession.DENTIST">DENTIST</option><option value="DENTAL_HYGIENIST" data-translate="getwellApp.Profession.DENTAL_HYGIENIST">DENTAL_HYGIENIST</option><option value="PROPHYLAXIS_ASSISTANT" data-translate="getwellApp.Profession.PROPHYLAXIS_ASSISTANT">PROPHYLAXIS_ASSISTANT</option><option value="DENTAL_ASSISTANT" data-translate="getwellApp.Profession.DENTAL_ASSISTANT">DENTAL_ASSISTANT</option><option value="ORTHODONTIST" data-translate="getwellApp.Profession.ORTHODONTIST">ORTHODONTIST</option><option value="ZUMEDO" data-translate="getwellApp.Profession.ZUMEDO">ZUMEDO</option></select><div ng-show="editForm.profession.$invalid"><p class="help-block" ng-show="editForm.profession.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.professionalCategory" for="field_professionalCategory">Professional Category</label><select class="form-control" name="professionalCategory" ng-model="vm.practitioner.professionalCategory" id="field_professionalCategory" required><option value="DENTAL_PRACTITIONER" data-translate="getwellApp.ProfessionalCategory.DENTAL_PRACTITIONER">DENTAL_PRACTITIONER</option><option value="PHYSICIAN" data-translate="getwellApp.ProfessionalCategory.PHYSICIAN">PHYSICIAN</option></select><div ng-show="editForm.professionalCategory.$invalid"><p class="help-block" ng-show="editForm.professionalCategory.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.practitioner.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.pictureUrl" for="field_pictureUrl">Picture Url</label><input type="text" class="form-control" name="pictureUrl" id="field_pictureUrl" ng-model="vm.practitioner.pictureUrl" ng-maxlength="100"><div ng-show="editForm.pictureUrl.$invalid"><p class="help-block" ng-show="editForm.pictureUrl.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.taxpunktwert" for="field_taxpunktwert">Taxpunktwert</label><input type="number" class="form-control" name="taxpunktwert" id="field_taxpunktwert" ng-model="vm.practitioner.taxpunktwert"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.externalCalendarId" for="field_externalCalendarId">External Calendar Id</label><input type="number" class="form-control" name="externalCalendarId" id="field_externalCalendarId" ng-model="vm.practitioner.externalCalendarId"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.externalCalendarData" for="field_externalCalendarData">External Calendar Data</label><input type="text" class="form-control" name="externalCalendarData" id="field_externalCalendarData" ng-model="vm.practitioner.externalCalendarData" ng-maxlength="50"><div ng-show="editForm.externalCalendarData.$invalid"><p class="help-block" ng-show="editForm.externalCalendarData.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.bookingPictureUrl" for="field_bookingPictureUrl">Booking Picture Url</label><input type="text" class="form-control" name="bookingPictureUrl" id="field_bookingPictureUrl" ng-model="vm.practitioner.bookingPictureUrl" ng-maxlength="100"><div ng-show="editForm.bookingPictureUrl.$invalid"><p class="help-block" ng-show="editForm.bookingPictureUrl.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.cvUrl" for="field_cvUrl">Cv Url</label><input type="text" class="form-control" name="cvUrl" id="field_cvUrl" ng-model="vm.practitioner.cvUrl" ng-maxlength="100"><div ng-show="editForm.cvUrl.$invalid"><p class="help-block" ng-show="editForm.cvUrl.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.customProfession" for="field_customProfession">Custom Profession</label><input type="text" class="form-control" name="customProfession" id="field_customProfession" ng-model="vm.practitioner.customProfession" ng-maxlength="150" placeholder="Custom profession, only for the practice profile, can be left empty in which case the default will be the practitioner profession"><div ng-show="editForm.customProfession.$invalid"><p class="help-block" ng-show="editForm.customProfession.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.sortingOrder" for="field_sortingOrder">Sorting Order</label><input type="number" class="form-control" name="sortingOrder" id="field_sortingOrder" ng-model="vm.practitioner.sortingOrder"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.practitioner.hideOnProfile" for="field_hideOnProfile">Hide On Profile</label><input type="checkbox" class="form-control" name="hideOnProfile" id="field_hideOnProfile" ng-model="vm.practitioner.hideOnProfile"></div><div class="form-group"><label data-translate="getwellApp.practitioner.treatment" for="field_treatment">Treatment</label><select class="form-control" id="field_treatment" multiple="multiple" name="treatment" ng-model="vm.practitioner.treatments" ng-options="treatment as ((\'getwellApp.TreatmentType.\' + treatment.type | translate) + \' (\' + treatment.id + \', \' + ((treatment.customName != null && treatment.customName != \'\') ? treatment.customName + \', \' : \'\') + treatment.practice.name + \')\') for treatment in vm.treatments track by treatment.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/practitioner/practitioners.html','<div><h2 data-translate="getwellApp.practitioner.home.title">Practitioners</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="practitioner.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="getwellApp.practitioner.home.createLabel">Create new Practitioner</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span data-translate="getwellApp.practitioner.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="salutation"><span data-translate="getwellApp.practitioner.salutation">Salutation</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firstname"><span data-translate="getwellApp.practitioner.firstname">Firstname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastname"><span data-translate="getwellApp.practitioner.lastname">Lastname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span data-translate="getwellApp.practitioner.phone">Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressStreet"><span data-translate="getwellApp.practitioner.addressStreet">Address Street</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressStreetNumber"><span data-translate="getwellApp.practitioner.addressStreetNumber">Address Street Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressCity"><span data-translate="getwellApp.practitioner.addressCity">Address City</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressPostalCode"><span data-translate="getwellApp.practitioner.addressPostalCode">Address Postal Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profession"><span data-translate="getwellApp.practitioner.profession">Profession</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="professionalCategory"><span data-translate="getwellApp.practitioner.professionalCategory">Professional Category</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="getwellApp.practitioner.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="praticeIds"><span data-translate="getwellApp.practice.detail.title">PracticeIds</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="praticeNames"><span data-translate="getwellApp.practice.detail.title">PracticeNames</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pictureUrl"><span data-translate="getwellApp.practitioner.pictureUrl">Picture Url</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="taxpunktwert"><span data-translate="getwellApp.practitioner.taxpunktwert">Taxpunktwert</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="externalCalendarId"><span data-translate="getwellApp.practitioner.externalCalendarId">External Calendar Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="externalCalendarData"><span data-translate="getwellApp.practitioner.externalCalendarData">External Calendar Data</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bookingPictureUrl"><span data-translate="getwellApp.practitioner.bookingPictureUrl">Booking Picture Url</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cvUrl"><span data-translate="getwellApp.practitioner.cvUrl">Cv Url</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="customProfession"><span data-translate="getwellApp.practitioner.customProfession">Custom Profession</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sortingOrder"><span data-translate="getwellApp.practitioner.sortingOrder">Sorting Order</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="hideOnProfile"><span data-translate="getwellApp.practitioner.hideOnProfile">Hide On Profile</span> <span class="glyphicon glyphicon-sort"></span></th><!--                     <th jh-sort-by="titleText"><span data-translate="getwellApp.practitioner.titleText">Title Text</span> <span class="glyphicon glyphicon-sort"></span></th> --><th></th></tr></thead><tbody><tr ng-repeat="practitioner in vm.practitioners track by practitioner.id"><td><a ui-sref="practitioner-detail({id:practitioner.id})">{{practitioner.id}}</a></td><td>{{practitioner.title}}</td><td data-translate="{{\'getwellApp.PractitionerSalutation.\' + practitioner.salutation}}">{{practitioner.salutation}}</td><td>{{practitioner.firstname}}</td><td>{{practitioner.lastname}}</td><td>{{practitioner.phone}}</td><td>{{practitioner.addressStreet}}</td><td>{{practitioner.addressStreetNumber}}</td><td>{{practitioner.addressCity}}</td><td>{{practitioner.addressPostalCode}}</td><td data-translate="{{\'getwellApp.Profession.\' + practitioner.profession}}">{{practitioner.profession}}</td><td data-translate="{{\'getwellApp.ProfessionalCategory.\' + practitioner.professionalCategory}}">{{practitioner.professionalCategory}}</td><td>{{practitioner.email}}</td><td>{{practitioner.practiceIds}}</td><td>{{practitioner.practiceNames}}</td><td>{{practitioner.pictureUrl}}</td><td>{{practitioner.taxpunktwert}}</td><td>{{practitioner.externalCalendarId}}</td><td>{{practitioner.externalCalendarData}}</td><td>{{practitioner.bookingPictureUrl}}</td><td>{{practitioner.cvUrl}}</td><td>{{practitioner.customProfession}}</td><td>{{practitioner.sortingOrder}}</td><td>{{practitioner.hideOnProfile}}</td><!--                     <td>{{practitioner.titleText}}</td> --><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="practitioner-detail({id:practitioner.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="practitioner.edit({id:practitioner.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="practitioner.delete({id:practitioner.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/treatment/add-default-treatments-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="defaultTreatmentsLabel">Add default treatments to a practice</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="getwellApp.treatment.practice" for="field_practice">Practice</label><select class="form-control" id="field_practice" name="practice" ng-model="vm.treatment.practice" ng-options="practice as practice.name for practice in vm.practices track by practice.id" required><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.type" for="field_type">Types</label><select class="form-control" name="type" ng-model="vm.treatments" id="field_type" required><option value="ROOT" data-translate="getwellApp.TreatmentType.ROOT">ROOT</option><option value="PAIN" data-translate="getwellApp.TreatmentType.PAIN">PAIN</option><option value="OTHER" data-translate="getwellApp.TreatmentType.OTHER">OTHER</option><option value="TOOTH_BROKEN" data-translate="getwellApp.TreatmentType.TOOTH_BROKEN">TOOTH_BROKEN</option><option value="GUM_PROBLEM" data-translate="getwellApp.TreatmentType.GUM_PROBLEM">GUM_PROBLEM</option><option value="FILLING" data-translate="getwellApp.TreatmentType.FILLING">FILLING</option><option value="WISDOM_TOOTH" data-translate="getwellApp.TreatmentType.WISDOM_TOOTH">WISDOM_TOOTH</option><option value="CONSULT_BRACE" data-translate="getwellApp.TreatmentType.CONSULT_BRACE">CONSULT_BRACE</option><option value="CROWN" data-translate="getwellApp.TreatmentType.CROWN">CROWN</option><option value="CONSULT_IMPLANT" data-translate="getwellApp.TreatmentType.CONSULT_IMPLANT">CONSULT_IMPLANT</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/treatment/treatment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.treatment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="getwellApp.treatment.delete.question" translate-values="{id: \'{{vm.treatment.id}}\'}">Are you sure you want to delete this Treatment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/treatment/treatment-detail.html','<div><h2><span data-translate="getwellApp.treatment.detail.title">Treatment</span> {{vm.treatment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="getwellApp.treatment.fixedPrice">Fixed Price</span></dt><dd><span>{{vm.treatment.fixedPrice}}</span></dd><dt><span data-translate="getwellApp.treatment.minPrice">Min Price</span></dt><dd><span>{{vm.treatment.minPrice}}</span></dd><dt><span data-translate="getwellApp.treatment.maxPrice">Max Price</span></dt><dd><span>{{vm.treatment.maxPrice}}</span></dd><dt><span data-translate="getwellApp.treatment.type">Type</span></dt><dd><span data-translate="{{\'getwellApp.TreatmentType.\' + vm.treatment.type}}">{{vm.treatment.type}}</span></dd><dt><span data-translate="getwellApp.treatment.duration">Duration</span></dt><dd><span>{{vm.treatment.duration}}</span></dd><dt><span data-translate="getwellApp.treatment.currency">Currency</span></dt><dd><span data-translate="{{\'getwellApp.Currency.\' + vm.treatment.currency}}">{{vm.treatment.currency}}</span></dd><dt><span data-translate="getwellApp.treatment.showPrice">Show Price</span></dt><dd><span>{{vm.treatment.showPrice}}</span></dd><dt><span data-translate="getwellApp.treatment.showDuration">Show Duration</span></dt><dd><span>{{vm.treatment.showDuration}}</span></dd><dt><span data-translate="getwellApp.treatment.displayOnStandalone">Display On Standalone</span></dt><dd><span>{{vm.treatment.displayOnStandalone}}</span></dd><dt><span data-translate="getwellApp.treatment.displayOnPlatform">Display On Platform</span></dt><dd><span>{{vm.treatment.displayOnPlatform}}</span></dd><dt><span data-translate="getwellApp.treatment.customName">Custom Name</span></dt><dd><span>{{vm.treatment.customName}}</span></dd><dt><span data-translate="getwellApp.treatment.sortingOrder">Sorting Order</span></dt><dd><span>{{vm.treatment.sortingOrder}}</span></dd><dt><span data-translate="getwellApp.treatment.externalCalendarId">External Calendar Id</span></dt><dd><span>{{vm.treatment.externalCalendarId}}</span></dd><dt><span data-translate="getwellApp.treatment.externalCalendarData">External Calendar Data</span></dt><dd><span>{{vm.treatment.externalCalendarData}}</span></dd><dt><span data-translate="getwellApp.treatment.practice">Practice</span></dt><dd><a ui-sref="practice-detail({id:vm.treatment.practice.id})">{{vm.treatment.practice.name}}</a></dd><dt><span data-translate="getwellApp.treatment.reductionCoupon">Reduction Coupon</span></dt><dd><a ui-sref="coupon-detail({id:vm.treatment.reductionCoupon.id})">{{vm.treatment.reductionCoupon.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="treatment-detail.edit({id:vm.treatment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/treatment/treatment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTreatmentLabel" data-translate="getwellApp.treatment.home.createOrEditLabel">Create or edit a Treatment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.treatment.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.treatment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.fixedPrice" for="field_fixedPrice">Fixed Price</label><input type="number" class="form-control" name="fixedPrice" id="field_fixedPrice" ng-model="vm.treatment.fixedPrice"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.minPrice" for="field_minPrice">Min Price</label><input type="number" class="form-control" name="minPrice" id="field_minPrice" ng-model="vm.treatment.minPrice"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.maxPrice" for="field_maxPrice">Max Price</label><input type="number" class="form-control" name="maxPrice" id="field_maxPrice" ng-model="vm.treatment.maxPrice"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.treatment.type" id="field_type" required><option value="CUSTOM" data-translate="getwellApp.TreatmentType.CUSTOM">CUSTOM</option><option value="EMERGENCY_NEW" data-translate="getwellApp.TreatmentType.EMERGENCY_NEW">EMERGENCY_NEW</option><option value="EMERGENCY_EXISTING" data-translate="getwellApp.TreatmentType.EMERGENCY_EXISTING">EMERGENCY_EXISTING</option><option value="DENTAL_HYGIENE" data-translate="getwellApp.TreatmentType.DENTAL_HYGIENE">DENTAL_HYGIENE</option><option value="CHECK_UP" data-translate="getwellApp.TreatmentType.CHECK_UP">CHECK_UP</option><option value="CHECK_UP_NEW" data-translate="getwellApp.TreatmentType.CHECK_UP_NEW">CHECK_UP_NEW</option><option value="CHECK_UP_EXISTING" data-translate="getwellApp.TreatmentType.CHECK_UP_EXISTING">CHECK_UP_EXISTING</option><option value="ZUMEDO_DEMO_ZH" data-translate="getwellApp.TreatmentType.ZUMEDO_DEMO_ZH">ZUMEDO_DEMO_ZH</option><option value="ZUMEDO_DEMO_BE" data-translate="getwellApp.TreatmentType.ZUMEDO_DEMO_BE">ZUMEDO_DEMO_BE</option><option value="ZUMEDO_CONSULTING_ZH" data-translate="getwellApp.TreatmentType.ZUMEDO_CONSULTING_ZH">ZUMEDO_CONSULTING_ZH</option><option value="CHECK_UP_HYGIENE" data-translate="getwellApp.TreatmentType.CHECK_UP_HYGIENE">CHECK_UP_HYGIENE</option><option value="APPOINTMENT" data-translate="getwellApp.TreatmentType.APPOINTMENT">APPOINTMENT</option><option value="CONSULT_BRACE" data-translate="getwellApp.TreatmentType.CONSULT_BRACE">CONSULT_BRACE</option><option value="CONSULT_IMPLANT" data-translate="getwellApp.TreatmentType.CONSULT_IMPLANT">CONSULT_IMPLANT</option><option value="CONSULT_BRIDGE" data-translate="getwellApp.TreatmentType.CONSULT_BRIDGE">CONSULT_BRIDGE</option><option value="TOOTH_BROKEN" data-translate="getwellApp.TreatmentType.TOOTH_BROKEN">TOOTH_BROKEN</option><option value="BLEACHING" data-translate="getwellApp.TreatmentType.BLEACHING">BLEACHING</option><option value="BLEACHING_HOME" data-translate="getwellApp.TreatmentType.BLEACHING_HOME">BLEACHING_HOME</option><option value="VENEER" data-translate="getwellApp.TreatmentType.VENEER">VENEER</option><option value="CROWN" data-translate="getwellApp.TreatmentType.CROWN">CROWN</option><option value="EMERGENCY" data-translate="getwellApp.TreatmentType.EMERGENCY">EMERGENCY</option><option value="FILLING" data-translate="getwellApp.TreatmentType.FILLING">FILLING</option><option value="ROOT" data-translate="getwellApp.TreatmentType.ROOT">ROOT</option><option value="PAIN" data-translate="getwellApp.TreatmentType.PAIN">PAIN</option><option value="GUM_PROBLEM" data-translate="getwellApp.TreatmentType.GUM_PROBLEM">GUM_PROBLEM</option><option value="WISDOM_TOOTH" data-translate="getwellApp.TreatmentType.WISDOM_TOOTH">WISDOM_TOOTH</option><option value="OTHER" data-translate="getwellApp.TreatmentType.OTHER">OTHER</option><option value="SECOND_OPINION_ORTHODONTICS" data-translate="getwellApp.TreatmentType.SECOND_OPINION_ORTHODONTICS">SECOND_OPINION_ORTHODONTICS</option><option value="CONSULT_ORTHODONTICS" data-translate="getwellApp.TreatmentType.CONSULT_ORTHODONTICS">CONSULT_ORTHODONTICS</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.duration" for="field_duration">Duration</label><input type="number" class="form-control" name="duration" id="field_duration" ng-model="vm.treatment.duration"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.currency" for="field_currency">Currency</label><select class="form-control" name="currency" ng-model="vm.treatment.currency" id="field_currency"><option value="CHF" data-translate="getwellApp.Currency.CHF">CHF</option><option value="EUR" data-translate="getwellApp.Currency.EUR">EUR</option><option value="USD" data-translate="getwellApp.Currency.USD">USD</option></select></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.showPrice" for="field_showPrice">Show Price</label><input type="checkbox" class="form-control" name="showPrice" id="field_showPrice" ng-model="vm.treatment.showPrice"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.showDuration" for="field_showDuration">Show Duration</label><input type="checkbox" class="form-control" name="showDuration" id="field_showDuration" ng-model="vm.treatment.showDuration"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.displayOnStandalone" for="field_displayOnStandalone">Display On Standalone</label><input type="checkbox" class="form-control" name="displayOnStandalone" id="field_displayOnStandalone" ng-model="vm.treatment.displayOnStandalone"><div ng-show="editForm.displayOnStandalone.$invalid"><p class="help-block" ng-show="editForm.displayOnStandalone.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.displayOnPlatform" for="field_displayOnPlatform">Display On Platform</label><input type="checkbox" class="form-control" name="displayOnPlatform" id="field_displayOnPlatform" ng-model="vm.treatment.displayOnPlatform"><div ng-show="editForm.displayOnPlatform.$invalid"><p class="help-block" ng-show="editForm.displayOnPlatform.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.customName" for="field_customName">Custom Name</label><input type="text" class="form-control" name="customName" id="field_customName" ng-model="vm.treatment.customName" ng-maxlength="70"><div ng-show="editForm.customName.$invalid"><p class="help-block" ng-show="editForm.customName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="70">This field cannot be longer than 70 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.sortingOrder" for="field_sortingOrder">Sorting Order</label><input type="number" class="form-control" name="sortingOrder" id="field_sortingOrder" ng-model="vm.treatment.sortingOrder"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.externalCalendarId" for="field_externalCalendarId">External Calendar Id</label><input type="number" class="form-control" name="externalCalendarId" id="field_externalCalendarId" ng-model="vm.treatment.externalCalendarId"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatment.externalCalendarData" for="field_externalCalendarData">External Calendar Data</label><input type="text" class="form-control" name="externalCalendarData" id="field_externalCalendarData" ng-model="vm.treatment.externalCalendarData" ng-maxlength="50"><div ng-show="editForm.externalCalendarData.$invalid"><p class="help-block" ng-show="editForm.externalCalendarData.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="getwellApp.treatment.practice" for="field_practice">Practice</label><input type="number" class="form-control" name="practice" id="field_practice" ng-model="vm.treatment.practice.id" required></div><div ng-show="editForm.practice.$invalid"><p class="help-block" ng-show="editForm.practice.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="getwellApp.treatment.reductionCoupon" for="field_reductionCoupon">Reduction Coupon</label><select class="form-control" id="field_reductionCoupon" name="reductionCoupon" ng-model="vm.treatment.reductionCoupon" ng-options="coupon as coupon.id for coupon in vm.coupons track by coupon.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/treatment/treatments.html','<div><h2 data-translate="getwellApp.treatment.home.title">Treatments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="treatment.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="getwellApp.treatment.home.createLabel">Create new Treatment</span></button></div><!--             <div class="col-xs-4 no-padding-left"> --><!--                 <button class="btn btn-primary" ui-sref="treatment.add-default-treatments" > --><!--                     <span class="glyphicon glyphicon-plus"></span> --><!--                     <span> --><!--                         Add default Treatments to a Practice --><!--                     </span> --><!--                 </button> --><!--             </div> --></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fixedPrice"><span data-translate="getwellApp.treatment.fixedPrice">Fixed Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="minPrice"><span data-translate="getwellApp.treatment.minPrice">Min Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="maxPrice"><span data-translate="getwellApp.treatment.maxPrice">Max Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="getwellApp.treatment.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="duration"><span data-translate="getwellApp.treatment.duration">Duration</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="currency"><span data-translate="getwellApp.treatment.currency">Currency</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="showPrice"><span data-translate="getwellApp.treatment.showPrice">Show Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="showDuration"><span data-translate="getwellApp.treatment.showDuration">Show Duration</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="displayOnStandalone"><span data-translate="getwellApp.treatment.displayOnStandalone">Display On Standalone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="displayOnPlatform"><span data-translate="getwellApp.treatment.displayOnPlatform">Display On Platform</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="customName"><span data-translate="getwellApp.treatment.customName">Custom Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sortingOrder"><span data-translate="getwellApp.treatment.sortingOrder">Sorting Order</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="externalCalendarId"><span data-translate="getwellApp.treatment.externalCalendarId">External Calendar Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="externalCalendarData"><span data-translate="getwellApp.treatment.externalCalendarData">External Calendar Data</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="practice.name"><span data-translate="getwellApp.treatment.practice">Practice</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="practice.id"><span data-translate="getwellApp.treatment.practice">Practice Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="reductionCoupon.id"><span data-translate="getwellApp.treatment.reductionCoupon">Reduction Coupon</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="treatment in vm.treatments track by treatment.id"><td><a ui-sref="treatment-detail({id:treatment.id})">{{treatment.id}}</a></td><td>{{treatment.fixedPrice}}</td><td>{{treatment.minPrice}}</td><td>{{treatment.maxPrice}}</td><td data-translate="{{\'getwellApp.TreatmentType.\' + treatment.type}}">{{treatment.type}}</td><td>{{treatment.duration}}</td><td data-translate="{{\'getwellApp.Currency.\' + treatment.currency}}">{{treatment.currency}}</td><td>{{treatment.showPrice}}</td><td>{{treatment.showDuration}}</td><td>{{treatment.displayOnStandalone}}</td><td>{{treatment.displayOnPlatform}}</td><td>{{treatment.customName}}</td><td>{{treatment.sortingOrder}}</td><td>{{treatment.externalCalendarId}}</td><td>{{treatment.externalCalendarData}}</td><td><a ui-sref="practice-detail({id:treatment.practice.id})">{{treatment.practice.name}}</a></td><td><a ui-sref="practice-detail({id:treatment.practice.id})">{{treatment.practice.id}}</a></td><td><a ui-sref="coupon-detail({id:treatment.reductionCoupon.id})">{{treatment.reductionCoupon.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="treatment-detail({id:treatment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="treatment.edit({id:treatment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="treatment.delete({id:treatment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/treatment-experience/treatment-experience-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.treatmentExperience.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="getwellApp.treatmentExperience.delete.question" translate-values="{id: \'{{vm.treatmentExperience.id}}\'}">Are you sure you want to delete this Treatment Experience?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/treatment-experience/treatment-experience-detail.html','<div><h2><span data-translate="getwellApp.treatmentExperience.detail.title">Treatment Experience</span> {{vm.treatmentExperience.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="getwellApp.treatmentExperience.date">Date</span></dt><dd><span>{{vm.treatmentExperience.date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="getwellApp.treatmentExperience.good">Good</span></dt><dd><span>{{vm.treatmentExperience.good}}</span></dd><dt><span data-translate="getwellApp.treatmentExperience.improvementPotential">Improvement Potential</span></dt><dd><span>{{vm.treatmentExperience.improvementPotential}}</span></dd><dt><span data-translate="getwellApp.treatmentExperience.summary">Summary</span></dt><dd><span>{{vm.treatmentExperience.summary}}</span></dd><dt><span data-translate="getwellApp.treatmentExperience.published">Published</span></dt><dd><span>{{vm.treatmentExperience.published}}</span></dd><dt><span data-translate="getwellApp.treatmentExperience.categoryGeneral">Category General</span></dt><dd><span>{{vm.treatmentExperience.categoryGeneral}}</span></dd><dt><span data-translate="getwellApp.treatmentExperience.categoryInformation">Category Information</span></dt><dd><span>{{vm.treatmentExperience.categoryInformation}}</span></dd><dt><span data-translate="getwellApp.treatmentExperience.categoryTimeTaken">Category Time Taken</span></dt><dd><span>{{vm.treatmentExperience.categoryTimeTaken}}</span></dd><dt><span data-translate="getwellApp.treatmentExperience.categoryFurnishing">Category Furnishing</span></dt><dd><span>{{vm.treatmentExperience.categoryFurnishing}}</span></dd><dt><span data-translate="getwellApp.treatmentExperience.categoryCostBenefit">Category Cost Benefit</span></dt><dd><span>{{vm.treatmentExperience.categoryCostBenefit}}</span></dd><dt><span data-translate="getwellApp.treatmentExperience.categoryPainlessness">Category Painlessness</span></dt><dd><span>{{vm.treatmentExperience.categoryPainlessness}}</span></dd><dt><span data-translate="getwellApp.treatmentExperience.overallRating">Overall Rating</span></dt><dd><span>{{vm.treatmentExperience.overallRating}}</span></dd><dt><span data-translate="getwellApp.treatmentExperience.booking">Booking</span></dt><dd><a ui-sref="booking-detail({id:vm.treatmentExperience.booking.id})">{{vm.treatmentExperience.booking.id}}</a></dd><dt><span data-translate="getwellApp.treatmentExperience.treatmentExperienceResponse">Treatment Experience Response</span></dt><dd><a ui-sref="treatment-experience-response-detail({id:vm.treatmentExperience.treatmentExperienceResponse.id})">{{vm.treatmentExperience.treatmentExperienceResponse.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="treatment-experience-detail.edit({id:vm.treatmentExperience.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/treatment-experience/treatment-experience-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTreatmentExperienceLabel" data-translate="getwellApp.treatmentExperience.home.createOrEditLabel">Create or edit a Treatment Experience</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.treatmentExperience.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.treatmentExperience.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperience.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.treatmentExperience.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperience.good" for="field_good">Good</label><input type="text" class="form-control" name="good" id="field_good" ng-model="vm.treatmentExperience.good" ng-maxlength="2000"><div ng-show="editForm.good.$invalid"><p class="help-block" ng-show="editForm.good.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2000">This field cannot be longer than 2000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperience.improvementPotential" for="field_improvementPotential">Improvement Potential</label><input type="text" class="form-control" name="improvementPotential" id="field_improvementPotential" ng-model="vm.treatmentExperience.improvementPotential" ng-maxlength="2000"><div ng-show="editForm.improvementPotential.$invalid"><p class="help-block" ng-show="editForm.improvementPotential.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2000">This field cannot be longer than 2000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperience.summary" for="field_summary">Summary</label><input type="text" class="form-control" name="summary" id="field_summary" ng-model="vm.treatmentExperience.summary" required ng-maxlength="100"><div ng-show="editForm.summary.$invalid"><p class="help-block" ng-show="editForm.summary.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.summary.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperience.published" for="field_published">Published</label><input type="checkbox" class="form-control" name="published" id="field_published" ng-model="vm.treatmentExperience.published"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperience.categoryGeneral" for="field_categoryGeneral">Category General</label><input type="number" class="form-control" name="categoryGeneral" id="field_categoryGeneral" ng-model="vm.treatmentExperience.categoryGeneral"><div ng-show="editForm.categoryGeneral.$invalid"><p class="help-block" ng-show="editForm.categoryGeneral.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperience.categoryInformation" for="field_categoryInformation">Category Information</label><input type="number" class="form-control" name="categoryInformation" id="field_categoryInformation" ng-model="vm.treatmentExperience.categoryInformation"><div ng-show="editForm.categoryInformation.$invalid"><p class="help-block" ng-show="editForm.categoryInformation.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperience.categoryTimeTaken" for="field_categoryTimeTaken">Category Time Taken</label><input type="number" class="form-control" name="categoryTimeTaken" id="field_categoryTimeTaken" ng-model="vm.treatmentExperience.categoryTimeTaken"><div ng-show="editForm.categoryTimeTaken.$invalid"><p class="help-block" ng-show="editForm.categoryTimeTaken.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperience.categoryFurnishing" for="field_categoryFurnishing">Category Furnishing</label><input type="number" class="form-control" name="categoryFurnishing" id="field_categoryFurnishing" ng-model="vm.treatmentExperience.categoryFurnishing"><div ng-show="editForm.categoryFurnishing.$invalid"><p class="help-block" ng-show="editForm.categoryFurnishing.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperience.categoryCostBenefit" for="field_categoryCostBenefit">Category Cost Benefit</label><input type="number" class="form-control" name="categoryCostBenefit" id="field_categoryCostBenefit" ng-model="vm.treatmentExperience.categoryCostBenefit"><div ng-show="editForm.categoryCostBenefit.$invalid"><p class="help-block" ng-show="editForm.categoryCostBenefit.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperience.categoryPainlessness" for="field_categoryPainlessness">Category Painlessness</label><input type="number" class="form-control" name="categoryPainlessness" id="field_categoryPainlessness" ng-model="vm.treatmentExperience.categoryPainlessness"><div ng-show="editForm.categoryPainlessness.$invalid"><p class="help-block" ng-show="editForm.categoryPainlessness.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperience.overallRating" for="field_overallRating">Overall Rating</label><input type="number" class="form-control" name="overallRating" id="field_overallRating" ng-model="vm.treatmentExperience.overallRating"><div ng-show="editForm.overallRating.$invalid"><p class="help-block" ng-show="editForm.overallRating.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="getwellApp.treatmentExperience.booking" for="field_booking">Booking</label><input type="number" class="form-control" name="booking" id="field_booking" ng-model="vm.treatmentExperience.booking.id" required></div><div class="form-group"><label data-translate="getwellApp.treatmentExperience.treatmentExperienceResponse" for="field_treatmentExperienceResponse">Treatment Experience Response</label><input type="number" class="form-control" name="treatmentExperienceResponse" id="field_treatmentExperienceResponse" ng-model="vm.treatmentExperience.treatmentExperienceResponse.id"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/treatment-experience/treatment-experiences.html','<div><h2 data-translate="getwellApp.treatmentExperience.home.title">Treatment Experiences</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="treatment-experience.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="getwellApp.treatmentExperience.home.createLabel">Create new Treatment Experience</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span data-translate="getwellApp.treatmentExperience.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="good"><span data-translate="getwellApp.treatmentExperience.good">Good</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="improvementPotential"><span data-translate="getwellApp.treatmentExperience.improvementPotential">Improvement Potential</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="summary"><span data-translate="getwellApp.treatmentExperience.summary">Summary</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="published"><span data-translate="getwellApp.treatmentExperience.published">Published</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="categoryGeneral"><span data-translate="getwellApp.treatmentExperience.categoryGeneral">Category General</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="categoryInformation"><span data-translate="getwellApp.treatmentExperience.categoryInformation">Category Information</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="categoryTimeTaken"><span data-translate="getwellApp.treatmentExperience.categoryTimeTaken">Category Time Taken</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="categoryFurnishing"><span data-translate="getwellApp.treatmentExperience.categoryFurnishing">Category Furnishing</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="categoryCostBenefit"><span data-translate="getwellApp.treatmentExperience.categoryCostBenefit">Category Cost Benefit</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="categoryPainlessness"><span data-translate="getwellApp.treatmentExperience.categoryPainlessness">Category Painlessness</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="overallRating"><span data-translate="getwellApp.treatmentExperience.overallRating">Overall Rating</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="booking.treatment.practice.id"><span data-translate="getwellApp.treatmentExperience.practice">Practice</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="booking.id"><span data-translate="getwellApp.treatmentExperience.booking">Booking</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="treatmentExperienceResponse.id"><span data-translate="getwellApp.treatmentExperience.treatmentExperienceResponse">Treatment Experience Response</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="treatmentExperience in vm.treatmentExperiences track by treatmentExperience.id"><td><a ui-sref="treatment-experience-detail({id:treatmentExperience.id})">{{treatmentExperience.id}}</a></td><td>{{treatmentExperience.date | date:\'mediumDate\'}}</td><td>{{treatmentExperience.good}}</td><td>{{treatmentExperience.improvementPotential}}</td><td>{{treatmentExperience.summary}}</td><td>{{treatmentExperience.published}}</td><td>{{treatmentExperience.categoryGeneral}}</td><td>{{treatmentExperience.categoryInformation}}</td><td>{{treatmentExperience.categoryTimeTaken}}</td><td>{{treatmentExperience.categoryFurnishing}}</td><td>{{treatmentExperience.categoryCostBenefit}}</td><td>{{treatmentExperience.categoryPainlessness}}</td><td>{{treatmentExperience.overallRating}}</td><td><a ui-sref="practice-detail({id:treatmentExperience.booking.treatment.practice.id})">{{treatmentExperience.booking.treatment.practice.name}}</a></td><td><a ui-sref="booking-detail({id:treatmentExperience.booking.id})">{{treatmentExperience.booking.id}}</a></td><td><a ui-sref="treatment-experience-response-detail({id:treatmentExperience.treatmentExperienceResponse.id})">{{treatmentExperience.treatmentExperienceResponse.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="treatment-experience-detail({id:treatmentExperience.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="treatment-experience.edit({id:treatmentExperience.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="treatment-experience.delete({id:treatmentExperience.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/treatment-experience-response/treatment-experience-response-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.treatmentExperienceResponse.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="getwellApp.treatmentExperienceResponse.delete.question" translate-values="{id: \'{{vm.treatmentExperienceResponse.id}}\'}">Are you sure you want to delete this Treatment Experience Response?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/treatment-experience-response/treatment-experience-response-detail.html','<div><h2><span data-translate="getwellApp.treatmentExperienceResponse.detail.title">Treatment Experience Response</span> {{vm.treatmentExperienceResponse.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="getwellApp.treatmentExperienceResponse.date">Date</span></dt><dd><span>{{vm.treatmentExperienceResponse.date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="getwellApp.treatmentExperienceResponse.message">Message</span></dt><dd><span>{{vm.treatmentExperienceResponse.message}}</span></dd><dt><span data-translate="getwellApp.treatmentExperienceResponse.name">Name</span></dt><dd><span>{{vm.treatmentExperienceResponse.name}}</span></dd><dt><span data-translate="getwellApp.treatmentExperienceResponse.pictureUrl">Picture Url</span></dt><dd><span>{{vm.treatmentExperienceResponse.pictureUrl}}</span></dd><dt><span data-translate="getwellApp.treatmentExperienceResponse.published">Published</span></dt><dd><span>{{vm.treatmentExperienceResponse.published}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="treatment-experience-response-detail.edit({id:vm.treatmentExperienceResponse.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/treatment-experience-response/treatment-experience-response-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTreatmentExperienceResponseLabel" data-translate="getwellApp.treatmentExperienceResponse.home.createOrEditLabel">Create or edit a Treatment Experience Response</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.treatmentExperienceResponse.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.treatmentExperienceResponse.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperienceResponse.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.treatmentExperienceResponse.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperienceResponse.message" for="field_message">Message</label><input type="text" class="form-control" name="message" id="field_message" ng-model="vm.treatmentExperienceResponse.message" required ng-maxlength="2000"><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.message.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2000">This field cannot be longer than 2000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperienceResponse.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.treatmentExperienceResponse.name" required ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperienceResponse.pictureUrl" for="field_pictureUrl">Picture Url</label><input type="text" class="form-control" name="pictureUrl" id="field_pictureUrl" ng-model="vm.treatmentExperienceResponse.pictureUrl" required ng-maxlength="100"><div ng-show="editForm.pictureUrl.$invalid"><p class="help-block" ng-show="editForm.pictureUrl.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.pictureUrl.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="getwellApp.treatmentExperienceResponse.published" for="field_published">Published</label><input type="checkbox" class="form-control" name="published" id="field_published" ng-model="vm.treatmentExperienceResponse.published"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/treatment-experience-response/treatment-experience-responses.html','<div><h2 data-translate="getwellApp.treatmentExperienceResponse.home.title">Treatment Experience Responses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="treatment-experience-response.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="getwellApp.treatmentExperienceResponse.home.createLabel">Create new Treatment Experience Response</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span data-translate="getwellApp.treatmentExperienceResponse.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="message"><span data-translate="getwellApp.treatmentExperienceResponse.message">Message</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="getwellApp.treatmentExperienceResponse.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pictureUrl"><span data-translate="getwellApp.treatmentExperienceResponse.pictureUrl">Picture Url</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="published"><span data-translate="getwellApp.treatmentExperienceResponse.published">Published</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="treatmentExperienceResponse in vm.treatmentExperienceResponses track by treatmentExperienceResponse.id"><td><a ui-sref="treatment-experience-response-detail({id:treatmentExperienceResponse.id})">{{treatmentExperienceResponse.id}}</a></td><td>{{treatmentExperienceResponse.date | date:\'mediumDate\'}}</td><td>{{treatmentExperienceResponse.message}}</td><td>{{treatmentExperienceResponse.name}}</td><td>{{treatmentExperienceResponse.pictureUrl}}</td><td>{{treatmentExperienceResponse.published}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="treatment-experience-response-detail({id:treatmentExperienceResponse.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="treatment-experience-response.edit({id:treatmentExperienceResponse.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="treatment-experience-response.delete({id:treatmentExperienceResponse.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><!--                 <img class="logo-img" src="content/images/logo-jhipster.png" alt="logo"/> --> <span data-translate="global.title">Zumedo</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'scheduler\')}" ng-switch-when="true" has-authority="ROLE_PRACTICE"><a ui-sref="scheduler" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-calendar"></span> <span class="hidden-sm" data-translate="global.menu.calendar">Calendar</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="calendar" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.calendar">Calendar</span></a></li><li ui-sref-active="active"><a ui-sref="practice({teaser: \'false\'})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.practice">Practice</span></a></li><li ui-sref-active="active"><a ui-sref="practice({teaser: \'true\'})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Teaser Practice</span></a></li><li ui-sref-active="active"><a ui-sref="practitioner" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.practitioner">Practitioner</span></a></li><li ui-sref-active="active"><a ui-sref="treatment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.treatment">Treatment</span></a></li><li ui-sref-active="active"><a ui-sref="end-customer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.endCustomer">End Customer</span></a></li><li ui-sref-active="active"><a ui-sref="booking" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.booking">Booking</span></a></li><li ui-sref-active="active"><a ui-sref="coupon" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.coupon">Coupon</span></a></li><li ui-sref-active="active"><a ui-sref="practice-profile" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.practiceProfile">Practice Profile</span></a></li><li ui-sref-active="active"><a ui-sref="treatment-experience" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.treatmentExperience">Treatment Experience</span></a></li><li ui-sref-active="active"><a ui-sref="treatment-experience-response" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.treatmentExperienceResponse">Treatment Experience Response</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><!--                         <li ui-sref-active="active" ng-switch-when="true"> --><!--                             <a ui-sref="settings" ng-click="vm.collapseNavbar()"> --><!--                                 <span class="glyphicon glyphicon-wrench"></span>&nbsp; --><!--                                 <span data-translate="global.menu.account.settings">Settings</span> --><!--                             </a> --><!--                         </li> --><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.account.sessions">Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><!--                         <li ui-sref-active="active" ng-switch-when="false"> --><!--                             <a ui-sref="register" ng-click="vm.collapseNavbar()"> --><!--                                 <span class="glyphicon glyphicon-plus-sign"></span>&nbsp; --><!--                                 <span data-translate="global.menu.account.register">Register</span> --><!--                             </a> --><!--                         </li> --></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-tracker" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span>&nbsp; <span data-translate="global.menu.admin.tracker">User tracker</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><!--                 <li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"> --><!--                     <a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"> --><!--                         <span> --><!--                             <span class="glyphicon glyphicon-flag"></span> --><!--                             <span class="hidden-sm" data-translate="global.menu.language">Language</span> --><!--                             <b class="caret"></b> --><!--                         </span> --><!--                     </a> --><!--                     <ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"> --><!--                         <li active-menu="{{language}}" ng-repeat="language in languageVm.languages"> --><!--                             <a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a> --><!--                         </li> --><!--                     </ul> --><!--                 </li> --></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();